const Sun = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 28 28"
  >
    <path d="M6.92094 8.69731C7.17227 8.94143 7.49209 9.06351 7.81274 9.06351C8.13258 9.06351 8.45237 8.94143 8.69654 8.69731C9.18482 8.20898 9.18482 7.41799 8.69654 6.92971L6.33977 4.57132C5.8531 4.08304 5.06045 4.08304 4.57216 4.57132C4.08388 5.0596 4.08388 5.85059 4.57216 6.33887L6.92094 8.69731ZM14.0001 6.50002C14.6902 6.50002 15.2501 5.94012 15.2501 5.25002V1.91669C15.2501 1.22658 14.6902 0.666687 14.0001 0.666687C13.31 0.666687 12.7501 1.22658 12.7501 1.91669V5.25002C12.7501 5.94012 13.31 6.50002 14.0001 6.50002ZM6.50008 14C6.50008 13.3099 5.94019 12.75 5.25008 12.75H1.91675C1.22664 12.75 0.666748 13.3099 0.666748 14C0.666748 14.6901 1.22664 15.25 1.91675 15.25H5.25008C5.94019 15.25 6.50008 14.6901 6.50008 14ZM20.1874 9.06351C20.5072 9.06351 20.8279 8.94143 21.0712 8.69726L23.420 6.33887C23.9163 5.85059 23.9163 5.0596 23.420 4.57132C22.9397 4.08304 22.1471 4.08304 21.6604 4.57132L19.3036 6.92971C18.8153 7.41799 18.8153 8.20898 19.3036 8.69726C19.5478 8.94143 19.8676 9.06351 20.1874 9.06351ZM14.0001 21.5C13.31 21.5 12.7501 22.0599 12.7501 22.75V26.0834C12.7501 26.7735 13.31 27.3334 14.0001 27.3334C14.6902 27.3334 15.2501 26.7735 15.2501 26.0834V22.75C15.2501 22.0599 14.6902 21.5 14.0001 21.5ZM6.92094 19.3027L4.57216 21.6612C4.08388 22.1494 4.08388 22.9404 4.57216 23.4207C4.81633 23.6729 5.13612 23.795 5.45597 23.795C5.77581 23.795 6.09644 23.6729 6.33977 23.4207L8.69654 21.0703C9.18482 20.5821 9.18482 19.7911 8.69654 19.3027C8.20826 18.8144 7.4156 18.8145 6.92094 19.3027ZM26.0834 12.75H22.7501C22.06 12.75 21.5001 13.3099 21.5001 14C21.5001 14.6901 22.06 15.25 22.7501 15.25H26.0834C26.7735 15.25 27.3334 14.6901 27.3334 14C27.3334 13.3099 26.7735 12.75 26.0834 12.75ZM21.0712 19.3027C20.5846 18.8144 19.7919 18.8144 19.3036 19.3027C18.8153 19.791 18.8153 20.5821 19.3036 21.0703L21.6604 23.4207C21.9037 23.6729 22.2244 23.795 22.5442 23.795C22.864 23.795 23.1838 23.6729 23.420 23.4207C23.9163 22.9404 23.9163 22.1494 23.420 21.6612L21.0712 19.3027ZM14.0001 8.16669C10.7785 8.16669 8.16675 10.7783 8.16675 14C8.16675 17.2216 10.7785 19.8334 14.0001 19.8334C17.2217 19.8334 19.8334 17.2216 19.8334 14C19.8334 10.7783 17.2217 8.16669 14.0001 8.16669Z" />
  </svg>
);

const Moon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
  >
    <path d="M0 10C0 4.47321 5.01516 0 11.1904 0C11.7584 0 12.6754 0.0744642 13.2354 0.167232C13.7163 0.246562 13.823 0.820357 13.3994 1.03509C10.6503 2.43304 8.96029 5.02679 8.96029 7.84821C8.96029 12.7455 13.946 16.4643 19.3756 15.5402C19.8537 15.4596 20.1897 15.9564 19.8812 16.2969C17.7956 18.5982 14.6405 20 11.1904 20C5.00516 20 0 15.5179 0 10Z" />
  </svg>
);

const Bell = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="28"
    viewBox="0 0 25 28"
  >
    <path
      d="M22.1155 17.0193C20.1472 15.0481 19.6239 13.4013 19.6239 12.029V10.7814C19.6239 6.10302 16.771 0.701008 11.738 1.0129C7.6891 1.26242 4.67425 4.90534 4.67425 8.95997V12.029C4.67425 13.4013 4.15101 15.0481 2.18264 17.0193C0.911916 18.2918 0.936832 19.5644 1.04895 22.0595C1.07387 22.7207 1.62203 23.2572 2.2823 23.2572H22.0034C22.6637 23.2572 23.2118 22.7332 23.2368 22.0595C23.3489 19.5519 23.3738 18.2794 22.1031 17.0193H22.1155Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.149 27C10.7786 27 9.65738 25.8772 9.65738 24.5048V23.2573H14.6406V24.5048C14.6406 25.8772 13.5194 27 12.149 27Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const EyeOpen = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 32 26"
  >
    <path
      d="M31 12.9999C31 12.9999 25.7826 22.4736 16 22.4736C6.21739 22.4736 1 12.9999 1 12.9999C1 12.9999 6.21739 3.52622 16 3.52622C25.7826 3.52622 31 12.9999 31 12.9999Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.9999 18.6842C19.2416 18.6842 21.8695 16.1393 21.8695 13C21.8695 9.8607 19.2416 7.3158 15.9999 7.3158C12.7583 7.3158 10.1304 9.8607 10.1304 13C10.1304 16.1393 12.7583 18.6842 15.9999 18.6842Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const EyeClosed = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 32 26"
  >
    <path
      d="M31 12.9999C31 12.9999 25.7826 22.4736 16 22.4736C6.21739 22.4736 1 12.9999 1 12.9999C1 12.9999 6.21739 3.52622 16 3.52622C25.7826 3.52622 31 12.9999 31 12.9999Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.9999 18.6842C19.2416 18.6842 21.8695 16.1393 21.8695 13C21.8695 9.8607 19.2416 7.3158 15.9999 7.3158C12.7583 7.3158 10.1304 9.8607 10.1304 13C10.1304 16.1393 12.7583 18.6842 15.9999 18.6842Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M27.087 1L4.91309 25"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const Hamburger = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
  >
    <circle
      cx="12"
      cy="12"
      r="12"
      className="fill-secondary-black dark:fill-primary-white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      className="dark:fill-secondary-black fill-primary-white"
      d="M6 7.5C6 7.08579 6.33579 6.75 6.75 6.75H17.25C17.6642 6.75 18 7.08579 18 7.5C18 7.91421 17.6642 8.25 17.25 8.25H6.75C6.33579 8.25 6 7.91421 6 7.5ZM6 12C6 11.5858 6.33579 11.25 6.75 11.25H17.25C17.6642 11.25 18 11.5858 18 12C18 12.4142 17.6642 12.75 17.25 12.75H6.75C6.33579 12.75 6 12.4142 6 12ZM6 16.5C6 16.0858 6.33579 15.75 6.75 15.75H17.25C17.6642 15.75 18 16.0858 18 16.5C18 16.9142 17.6642 17.25 17.25 17.25H6.75C6.33579 17.25 6 16.9142 6 16.5Z"
    />
  </svg>
);

const Close = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
  >
    <circle
      cx="12"
      cy="12"
      r="12"
      className="fill-secondary-black dark:fill-primary-white"
    />
    <path
      d="M7.5 7.5L16.5 16.5"
      className="dark:stroke-secondary-black stroke-primary-white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.5 16.5L16.5 7.5"
      className="dark:stroke-secondary-black stroke-primary-white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const Account = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 19 19"
    fill="none"
  >
    <path
      d="M3.70522 15.7161C4.65131 13.5874 6.89087 12.087 9.5 12.087C12.1091 12.087 14.3487 13.5874 15.2948 15.7161M12.087 7.69132C12.087 9.28045 10.6604 10.5296 9.01957 10.2339C7.85174 10.0196 6.91304 8.75567 6.91304 7.56567V6.78219C6.91304 5.59219 7.84435 4.32088 9.01957 4.11393C10.6604 3.81827 12.087 5.0674 12.087 6.65654V7.69132ZM18 9.5C18 14.1944 14.1944 18 9.5 18C4.80558 18 1 14.1944 1 9.5C1 4.80558 4.80558 1 9.5 1C14.1944 1 18 4.80558 18 9.5Z"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const AccountCircle = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
  >
    <circle
      cx="12"
      cy="12"
      r="12"
      fill="white"
      className="fill-secondary-black dark:fill-primary-white"
    />
    <path
      className="dark:fill-secondary-black fill-primary-white"
      d="M3.08619 20.8203C2.86188 21.325 3.08918 21.916 3.59386 22.1403C4.09855 22.3646 4.68951 22.1373 4.91381 21.6326L3.08619 20.8203ZM19.5742 21.6326C19.7985 22.1373 20.3895 22.3646 20.8942 22.1403C21.3989 21.916 21.6262 21.325 21.4019 20.8203L19.5742 21.6326ZM4.91381 21.6326C6.09409 18.977 8.91439 17.0634 12.244 17.0634V15.0634C8.14983 15.0634 4.59783 17.4191 3.08619 20.8203L4.91381 21.6326ZM12.244 17.0634C15.5737 17.0634 18.394 18.977 19.5742 21.6326L21.4019 20.8203C19.8902 17.4191 16.3382 15.0634 12.244 15.0634V17.0634ZM15.6415 11.2838C15.6415 13.1601 14.1205 14.6811 12.2442 14.6811V16.6811C15.225 16.6811 17.6415 14.2647 17.6415 11.2838H15.6415ZM12.2442 14.6811C10.3679 14.6811 8.84685 13.1601 8.84685 11.2838H6.84685C6.84685 14.2647 9.26332 16.6811 12.2442 16.6811V14.6811ZM8.84685 11.2838C8.84685 9.40751 10.3679 7.88647 12.2442 7.88647V5.88647C9.26332 5.88647 6.84685 8.30294 6.84685 11.2838H8.84685ZM12.2442 7.88647C14.1205 7.88647 15.6415 9.40751 15.6415 11.2838H17.6415C17.6415 8.30294 15.225 5.88647 12.2442 5.88647V7.88647Z"
    />
  </svg>
);

const Address = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 17 19"
    fill="none"
  >
    <path
      d="M2.21739 13.087L1 18L4.69565 16.5217L8.3913 18L12.087 16.5217L15.7826 18L14.5652 13.087M13.5652 6.17391C13.5652 9.03435 8.3913 14.0435 8.3913 14.0435C8.3913 14.0435 3.21739 9.03435 3.21739 6.17391C3.21739 3.31348 5.53087 1 8.3913 1C11.2517 1 13.5652 3.31348 13.5652 6.17391Z"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const Settings = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 19 19"
    fill="none"
  >
    <path
      d="M4.01565 6.44739L2.70739 4.27435L4.27435 2.70739L6.44739 4.01565C6.8613 3.77913 7.30478 3.59435 7.77783 3.4613L8.3913 1H10.6087L11.2222 3.4613C11.6952 3.59435 12.1387 3.77913 12.5526 4.01565L14.7257 2.70739L16.2926 4.27435L14.9843 6.44739C15.2209 6.8613 15.4057 7.30478 15.5387 7.77783L18 8.3913V10.6087L15.5387 11.2222C15.4057 11.6952 15.2209 12.1387 14.9843 12.5526L16.2926 14.7257L14.7257 16.2926L12.5526 14.9843C12.1387 15.2209 11.6952 15.4057 11.2222 15.5387L10.6087 18H8.3913L7.77783 15.5387C7.30478 15.4057 6.8613 15.2209 6.44739 14.9843L4.27435 16.2926L2.70739 14.7257L4.01565 12.5526C3.77913 12.1387 3.59435 11.6952 3.4613 11.2222L1 10.6087V8.3913L3.4613 7.77783C3.59435 7.30478 3.77913 6.8613 4.01565 6.44739Z"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.5 12.8261C11.3369 12.8261 12.8261 11.3369 12.8261 9.5C12.8261 7.66305 11.3369 6.17391 9.5 6.17391C7.66305 6.17391 6.17391 7.66305 6.17391 9.5C6.17391 11.3369 7.66305 12.8261 9.5 12.8261Z"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const Bills = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 16 19"
    fill="none"
  >
    <path
      d="M4.69565 6.91304H10.6087M4.69565 9.86957H10.6087M4.69565 12.8261H10.6087M1 1L3.21739 3.21739L5.43478 1L7.65217 3.21739L9.86957 1L12.087 3.21739L14.3043 1V18L12.087 15.7826L9.86957 18L7.65217 15.7826L5.43478 18L3.21739 15.7826L1 18V1Z"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const Edit = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 22 22"
    fill="none"
  >
    <path
      d="M14.9102 3.61228L18.3877 7.08982M2.73877 15.7786L17.5173 1L20.9968 4.47948L6.21825 19.258L2.73877 15.7786ZM1 21L6.21632 19.2612L2.73877 15.7837L1 21Z"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const Pause = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 18 22"
    fill="none"
  >
    <path
      d="M5 21H1V1H5V21ZM17 1H13V21H17V1Z"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const Resume = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 16 20"
  >
    <path d="M0 0V20L16 10L0 0Z" />
  </svg>
);

const Remove = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22" fill="none">
    <path
      d="M20.7362 2.69786L19.3021 1.26381C18.9504 0.912063 18.3822 0.912063 18.0304 1.26381L11.6359 7.6584C11.2841 8.01015 10.7159 8.01015 10.3641 7.6584L3.96956 1.26381C3.61781 0.912063 3.04961 0.912063 2.69786 1.26381L1.26381 2.69786C0.912063 3.04961 0.912063 3.61781 1.26381 3.96956L7.6584 10.3641C8.01015 10.7159 8.01015 11.2841 7.6584 11.6359L1.26381 18.0304C0.912063 18.3822 0.912063 18.9504 1.26381 19.3021L2.69786 20.7362C3.04961 21.0879 3.61781 21.0879 3.96956 20.7362L10.3641 14.3416C10.7159 13.9899 11.2841 13.9899 11.6359 14.3416L18.0304 20.7362C18.3822 21.0879 18.9504 21.0879 19.3021 20.7362L20.7362 19.3021C21.0879 18.9504 21.0879 18.3822 20.7362 18.0304L14.3416 11.6359C13.9899 11.2841 13.9899 10.7159 14.3416 10.3641L20.7362 3.96956C21.0879 3.61781 21.0879 3.04961 20.7362 2.69786Z"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const Wishlist = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 18 18"
    fill="none"
  >
    <path
      d="M9.77478 1.55533L11.0872 5.70421C11.1926 6.03921 11.5088 6.26083 11.8619 6.26083H16.1891C16.9639 6.26083 17.2959 7.22461 16.6793 7.6833L13.1111 10.3479C12.8423 10.5489 12.7263 10.8942 12.8265 11.2137L14.1705 15.476C14.4024 16.213 13.5327 16.8108 12.9002 16.3418L9.4849 13.7907C9.19501 13.5742 8.78918 13.5742 8.49929 13.7907L5.08395 16.3418C4.45675 16.8108 3.58183 16.213 3.81373 15.476L5.15774 11.2137C5.25788 10.8942 5.1472 10.5489 4.87312 10.3479L1.32074 7.68846C0.704083 7.22976 1.03613 6.26598 1.81091 6.26598H6.13807C6.49647 6.26598 6.80743 6.03921 6.91284 5.70936L8.22522 1.56049C8.4624 0.813172 9.5376 0.813172 9.77478 1.56049V1.55533Z"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const Help = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 19 19"
    fill="none"
  >
    <path
      d="M9.5 14.0001C9.78 14.0001 10 13.7917 10 13.5264C10 13.2612 9.78 13.0527 9.5 13.0527C9.22 13.0527 9 13.2612 9 13.5264C9 13.7917 9.22 14.0001 9.5 14.0001Z"
      strokeWidth="0.5"
    />
    <path
      d="M8 7.36842C8 6.58211 8.67 5.94737 9.5 5.94737C10.33 5.94737 11 6.58211 11 7.36842C11 8.15474 10.33 8.78947 9.5 8.78947C9.22 8.78947 9 8.99789 9 9.26316V10.6842C9 10.9495 9.22 11.1579 9.5 11.1579C9.78 11.1579 10 10.9495 10 10.6842V9.68947C11.14 9.47158 12 8.51474 12 7.36842C12 6.06105 10.88 5 9.5 5C8.12 5 7 6.06105 7 7.36842C7 7.63368 7.22 7.84211 7.5 7.84211C7.78 7.84211 8 7.63368 8 7.36842Z"
      strokeWidth="0.5"
    />
    <path
      d="M9.5 18C14.1944 18 18 14.1944 18 9.5C18 4.80558 14.1944 1 9.5 1C4.80558 1 1 4.80558 1 9.5C1 14.1944 4.80558 18 9.5 18Z"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const Orders = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 16 19"
    fill="none"
  >
    <path
      d="M11 7L7.49995 12.5L5 9.8397M1 1L3.21739 3.21739L5.43478 1L7.65217 3.21739L9.86957 1L12.087 3.21739L14.3043 1V18L12.087 15.7826L9.86957 18L7.65217 15.7826L5.43478 18L3.21739 15.7826L1 18V1Z"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const Arrow = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 12 18"
    fill="none"
  >
    <path
      d="M1 17L11 9L1 1"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ArrowCircle = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 16 16"
    fill="none"
  >
    <circle
      cx="8"
      cy="8"
      r="8"
      className="fill-primary-black dark:fill-primary-white"
    />
    <path
      className="fill-primary-white dark:fill-primary-magenta"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.40004 4.54998C5.64857 4.21861 6.11867 4.15145 6.45004 4.39998L10.45 7.39998C10.6389 7.54162 10.75 7.76392 10.75 7.99998C10.75 8.23605 10.6389 8.45834 10.45 8.59998L6.45004 11.6C6.11867 11.8485 5.64857 11.7814 5.40004 11.45C5.15152 11.1186 5.21867 10.6485 5.55004 10.4L8.75004 7.99998L5.55004 5.59998C5.21867 5.35145 5.15152 4.88135 5.40004 4.54998Z"
    />
  </svg>
);

const ArrowSquare = (
  <svg
    width="100%"
    height="100%"
    version="1.1"
    viewBox="0 0 100 100"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="m36 33c0-1.6562-1.3438-3-3-3s-3 1.3438-3 3v34c0 1.6562 1.3438 3 3 3h34c1.6562 0 3-1.3438 3-3s-1.3438-3-3-3h-26.758l28.879-28.879c1.1719-1.1719 1.1719-3.0703 0-4.2422s-3.0703-1.1719-4.2422 0l-28.879 28.879z" />
  </svg>
);

const Search = (
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 1000 1000"
  >
    <path
      fill="none"
      stroke-linejoixn="round"
      strokeLinecap="round"
      strokeMiterlimit="4"
      strokeWidth="109.7143"
      d="m950.875 950.853 -291.555 -291.555m100.729 -242.702c0 189.685 -153.768 343.453 -343.453 343.453S73.143 606.281 73.143 416.596 226.912 73.143 416.596 73.143s343.453 153.769 343.453 343.453"
    ></path>
  </svg>
);

const SearchCircle = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <circle
      cx="12"
      cy="12"
      r="12"
      className="fill-primary-black dark:fill-primary-white"
    />
    <path
      className="fill-primary-white dark:fill-primary-black"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16ZM12 18C15.3137 18 18 15.3137 18 12C18 8.68629 15.3137 6 12 6C8.68629 6 6 8.68629 6 12C6 15.3137 8.68629 18 12 18Z"
    />
    <path
      className="fill-primary-white dark:fill-primary-black"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.1924 21.6065L14.5858 16.9999L16 15.5857L20.6899 20.2756C20.229 20.7595 19.728 21.2049 19.1924 21.6065Z"
    />
    <path
      className="fill-primary-white dark:fill-primary-black"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.6899 20.2756L16 15.5857L14.5858 16.9999L19.1924 21.6065C19.728 21.2049 20.229 20.7595 20.6899 20.2756Z"
    />
  </svg>
);

const Visa = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 65 21"
    fill="none"
  >
    <path d="M47.2154 1.23264C45.7183 0.684748 44.1372 0.410317 42.5435 0.420984C37.3925 0.420984 33.7541 3.02662 33.729 6.76682C33.6971 9.51404 36.3146 11.0627 38.2946 11.981C40.3259 12.9245 41.0058 13.5199 40.9991 14.3636C40.9865 15.6465 39.3764 16.2284 37.8793 16.2284C35.822 16.2284 34.6987 15.9404 32.9698 15.2199L32.3295 14.9192L31.5983 19.2248C32.851 19.7485 35.1073 20.1974 37.4389 20.2362C42.9153 20.2362 46.4958 17.6471 46.5373 13.6683C46.5827 11.4738 45.1658 9.81562 42.1842 8.44444C40.3713 7.55521 39.248 6.96077 39.248 6.05893C39.248 5.26085 40.2109 4.4075 42.2228 4.4075C43.5625 4.37453 44.8925 4.62762 46.1278 5.14739L46.6107 5.36364L47.3419 1.20355L47.2163 1.23264H47.2154ZM60.5829 0.770083H56.5582C55.3055 0.770083 54.3628 1.11627 53.8151 2.36333L46.0756 19.9666H51.5521L52.6464 17.0798L59.3302 17.0866C59.4876 17.7625 59.9706 19.9666 59.9706 19.9666H64.7999L60.5829 0.770083ZM26.3208 0.60911H31.5394L28.2748 19.8163H23.062L26.3208 0.602322V0.60911ZM13.072 11.1946L13.6129 13.8613L18.7127 0.770083H24.2403L16.0276 19.9414H10.5125L6.00482 3.70833C5.93141 3.44069 5.76045 3.21087 5.52478 3.06541C3.90116 2.22272 2.17903 1.58368 0.399902 1.16185L0.47041 0.757477H8.87054C10.0103 0.803053 10.9278 1.16185 11.234 2.3837L13.0692 11.2052V11.1955H13.072V11.1946ZM54.1435 13.1534L56.223 7.78115C56.1969 7.83933 56.6509 6.67276 56.9156 5.95129L57.2729 7.60951L58.4803 13.1495H54.1406V13.1524H54.1435V13.1534Z" />
  </svg>
);

const Maestro = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 65 51"
    fill="none"
  >
    <path d="M62.6921 32.6139V31.9704H62.9516V31.8326H62.2953V31.9704H62.5548V32.6139H62.6921ZM63.974 32.6139V31.8326H63.7756L63.5467 32.3688L63.3178 31.8326H63.1194V32.6139H63.2568V32.0317L63.4704 32.5373H63.623L63.8367 32.0317V32.6139H63.974ZM19.6723 50.2644V46.9396C19.6723 45.6832 18.8788 44.8405 17.5969 44.8405C16.9254 44.8405 16.2234 45.0397 15.7503 45.7905C15.3841 45.2083 14.8194 44.8405 14.0106 44.8405C13.446 44.8405 12.8966 45.0091 12.4693 45.622V44.9631H11.3247V50.2644H12.4845V47.3226C12.4845 46.4033 12.9881 45.9131 13.7817 45.9131C14.5753 45.9131 14.9262 46.4033 14.9262 47.3073V50.2644H16.0861V47.3226C16.0861 46.4033 16.6202 45.9131 17.3832 45.9131C18.1462 45.9131 18.543 46.4033 18.543 47.3073V50.2644H19.7028H19.6723ZM26.1428 47.6138V44.9631H24.9983V45.6066C24.632 45.1317 24.0826 44.8252 23.3349 44.8252C21.8546 44.8252 20.6948 45.9897 20.6948 47.6138C20.6948 49.2378 21.8546 50.387 23.3349 50.387C24.0826 50.387 24.632 50.0958 24.9983 49.6056V50.2491H26.1428V47.5984V47.6138ZM21.8698 47.6138C21.8698 46.6791 22.4803 45.9131 23.4722 45.9131C24.4642 45.9131 25.0593 46.6485 25.0593 47.6138C25.0593 48.579 24.4184 49.3144 23.4722 49.3144C22.5261 49.3144 21.8698 48.5484 21.8698 47.6138ZM50.6972 44.8252C51.1093 44.8252 51.4755 44.9018 51.8265 45.0397C52.1775 45.1776 52.4675 45.3768 52.7269 45.622C52.9863 45.8671 53.1847 46.1582 53.3221 46.5106C53.4594 46.8477 53.5357 47.2154 53.5357 47.6138C53.5357 48.0121 53.4594 48.3798 53.3221 48.7169C53.1847 49.054 52.9863 49.3451 52.7269 49.6056C52.4675 49.8507 52.1775 50.0499 51.8265 50.1878C51.4755 50.3257 51.094 50.4023 50.6972 50.4023C50.3005 50.4023 49.9189 50.3257 49.568 50.1878C49.217 50.0499 48.927 49.8507 48.6676 49.6056C48.4234 49.3604 48.225 49.0693 48.0724 48.7169C47.9351 48.3798 47.8588 48.0121 47.8588 47.6138C47.8588 47.2154 47.9351 46.8477 48.0724 46.5106C48.2098 46.1735 48.4081 45.8824 48.6676 45.622C48.9117 45.3768 49.217 45.1776 49.568 45.0397C49.9189 44.9018 50.3005 44.8252 50.6972 44.8252ZM50.6972 45.9131C50.4683 45.9131 50.2394 45.959 50.041 46.0356C49.8426 46.1122 49.6595 46.2348 49.5222 46.388C49.3696 46.5412 49.2627 46.7098 49.1712 46.9243C49.0796 47.1388 49.0491 47.3686 49.0491 47.6138C49.0491 47.8589 49.0949 48.0887 49.1712 48.3032C49.2475 48.5177 49.3696 48.6863 49.5222 48.8395C49.6748 48.9927 49.8426 49.0999 50.041 49.1919C50.2394 49.2685 50.4531 49.3144 50.6972 49.3144C50.9414 49.3144 51.1551 49.2685 51.3535 49.1919C51.5518 49.1153 51.735 48.9927 51.8876 48.8395C52.0402 48.6863 52.147 48.5177 52.2386 48.3032C52.3149 48.0887 52.3607 47.8589 52.3607 47.6138C52.3607 47.3686 52.3149 47.1388 52.2386 46.9243C52.147 46.7098 52.0402 46.5412 51.8876 46.388C51.735 46.2348 51.5671 46.1276 51.3535 46.0356C51.1551 45.959 50.9262 45.9131 50.6972 45.9131ZM32.3844 47.6138C32.3844 45.959 31.362 44.8252 29.8817 44.8252C28.4014 44.8252 27.2569 45.959 27.2569 47.6138C27.2569 49.2685 28.3862 50.387 29.958 50.387C30.7516 50.387 31.4841 50.1878 32.125 49.6515L31.5604 48.7935C31.1178 49.1459 30.5532 49.3451 30.019 49.3451C29.2865 49.3451 28.5998 49.008 28.4472 48.0428H32.3692C32.3692 47.9049 32.3844 47.7516 32.3844 47.5984M28.4472 47.1388C28.5693 46.3727 29.0271 45.8518 29.8512 45.8518C30.5837 45.8518 31.0568 46.3114 31.1941 47.1388H28.4625H28.4472ZM37.2221 46.3114C36.9016 46.1122 36.2454 45.8518 35.5739 45.8518C34.9482 45.8518 34.5667 46.0816 34.5667 46.4646C34.5667 46.817 34.9635 46.9243 35.4671 46.9856L36.0165 47.0622C37.161 47.2307 37.863 47.721 37.863 48.6556C37.863 49.6668 36.9779 50.387 35.4518 50.387C34.5972 50.387 33.7884 50.1725 33.1627 49.6975L33.6969 48.7935C34.0784 49.0999 34.6583 49.3451 35.4518 49.3451C36.2454 49.3451 36.6574 49.1153 36.6574 48.7016C36.6574 48.4105 36.3522 48.2419 35.7265 48.15L35.1771 48.0734C34.0021 47.9049 33.3611 47.3686 33.3611 46.5106C33.3611 45.4534 34.2157 44.8099 35.5587 44.8099C36.398 44.8099 37.161 44.9938 37.7104 45.3615L37.2068 46.2961L37.2221 46.3114ZM42.7312 46.0203H40.8541V48.4105C40.8541 48.9467 41.0372 49.2991 41.6171 49.2991C41.9224 49.2991 42.2886 49.1919 42.6396 48.9927L42.9753 49.9733C42.6091 50.2337 42.0292 50.387 41.5408 50.387C40.1826 50.387 39.7096 49.6515 39.7096 48.4258V46.005H38.6413V44.9478H39.7096V43.339H40.8694V44.9478H42.7464V46.005L42.7312 46.0203ZM46.7142 44.8252C46.9431 44.8252 47.2789 44.8712 47.5383 44.9631L47.1873 46.051C46.9431 45.9437 46.6989 45.9131 46.47 45.9131C45.7223 45.9131 45.3407 46.4034 45.3407 47.2767V50.2491H44.1962V44.9478H45.3255V45.5913C45.6307 45.1317 46.058 44.8099 46.7142 44.8099M54.6498 49.3451C54.6498 49.3451 54.7871 49.3451 54.8634 49.3911C54.9244 49.4217 54.9855 49.4523 55.0313 49.4983C55.0771 49.5443 55.1228 49.6056 55.1534 49.6668C55.1839 49.7281 55.1991 49.8047 55.1991 49.866C55.1991 49.9273 55.1991 50.0039 55.1534 50.0652C55.1228 50.1265 55.0923 50.1878 55.0313 50.2337C54.9855 50.2797 54.9244 50.3257 54.8634 50.341C54.8024 50.3716 54.7261 50.387 54.6498 50.387C54.5734 50.387 54.4971 50.387 54.4361 50.341C54.3751 50.3103 54.314 50.2797 54.2682 50.2337C54.2225 50.1878 54.1767 50.1265 54.1461 50.0652C54.1156 50.0039 54.1004 49.9273 54.1004 49.866C54.1004 49.8047 54.1004 49.7281 54.1461 49.6668C54.1767 49.6056 54.2072 49.5443 54.2682 49.4983C54.314 49.4523 54.3751 49.4064 54.4361 49.3911C54.4971 49.3757 54.5734 49.3451 54.6498 49.3451ZM54.6498 50.2797C54.6498 50.2797 54.7566 50.2797 54.8024 50.2491C54.8481 50.2337 54.8939 50.2031 54.9244 50.1571C54.955 50.1112 54.9855 50.0805 55.016 50.0192C55.0313 49.9733 55.0465 49.912 55.0465 49.866C55.0465 49.8201 55.0465 49.7588 55.016 49.7128C55.0007 49.6668 54.9702 49.6209 54.9244 49.5749C54.8939 49.5443 54.8481 49.5136 54.8024 49.483C54.7566 49.4677 54.6955 49.4523 54.6498 49.4523C54.604 49.4523 54.5429 49.4523 54.4819 49.483C54.4361 49.4983 54.3903 49.5289 54.3598 49.5749C54.3293 49.6056 54.2988 49.6515 54.2682 49.7128C54.253 49.7588 54.2377 49.8201 54.2377 49.866C54.2377 49.912 54.2377 49.9733 54.2682 50.0192C54.2835 50.0652 54.314 50.1112 54.3598 50.1571C54.3903 50.1878 54.4361 50.2184 54.4819 50.2491C54.5277 50.2644 54.5887 50.2797 54.6498 50.2797ZM54.6803 49.6362C54.6803 49.6362 54.7871 49.6362 54.8329 49.6822C54.8634 49.7128 54.8787 49.7435 54.8787 49.7894C54.8787 49.8354 54.8787 49.866 54.8329 49.8967C54.8024 49.9273 54.7718 49.9426 54.7261 49.9426L54.8787 50.1265H54.7566L54.604 49.9426H54.5582V50.1265H54.4514V49.6362H54.6803ZM54.5582 49.7281V49.8507H54.6803C54.6803 49.8507 54.7261 49.8507 54.7413 49.8354C54.7566 49.8354 54.7718 49.8047 54.7718 49.7894C54.7718 49.7741 54.7718 49.7588 54.7413 49.7434C54.7261 49.7434 54.7108 49.7434 54.6803 49.7434H54.5582V49.7281ZM30.6295 36.475C30.7821 36.6129 30.9499 36.7354 31.1178 36.8733C27.9589 38.9877 24.1742 40.2134 20.0996 40.2134C9.11193 40.2134 0.199707 31.2657 0.199707 20.2341C0.199707 9.20261 9.11193 0.254822 20.0996 0.254822C24.1742 0.254822 27.9589 1.48055 31.1178 3.59492C30.9499 3.73282 30.7973 3.85539 30.6295 3.99328C25.9444 8.08414 23.2586 14.0136 23.2586 20.2341C23.2586 26.4547 25.9444 32.3841 30.6295 36.475ZM44.6998 0.254822C40.6252 0.254822 36.8406 1.48055 33.6816 3.59492C33.8495 3.73282 34.0021 3.85539 34.1699 3.99328C38.855 8.08414 41.5408 14.0136 41.5408 20.2341C41.5408 26.4547 38.855 32.3841 34.1699 36.475C34.0173 36.6129 33.8495 36.7354 33.6816 36.8733C36.8406 38.9877 40.6252 40.2134 44.6998 40.2134C55.6875 40.2134 64.5997 31.2657 64.5997 20.2341C64.5997 9.20261 55.6875 0.254822 44.6998 0.254822ZM32.3997 4.52954C32.1403 4.72872 31.8961 4.94322 31.6519 5.15772C27.4553 8.81957 24.7999 14.2128 24.7999 20.2341C24.7999 26.2555 27.4553 31.6487 31.6519 35.3105C31.8961 35.525 32.1403 35.7395 32.3997 35.9387C32.6591 35.7395 32.9033 35.525 33.1475 35.3105C37.3442 31.6487 39.9995 26.2555 39.9995 20.2341C39.9995 14.2128 37.3442 8.81957 33.1475 5.15772C32.9033 4.94322 32.6591 4.72872 32.3997 4.52954Z" />
  </svg>
);

const Amex = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 65 65"
    fill="none"
  >
    <path d="M42.987 38.7336C42.987 37.8647 42.6248 37.4 42.0612 37.0565C41.4977 36.7332 40.8135 36.6928 39.8877 36.6928H35.742V44.29H37.5532V41.5219H39.4853C40.1293 41.5219 40.5317 41.5825 40.7733 41.8654C41.0953 42.2089 41.055 42.8757 41.055 43.3606V44.29H42.826V42.7948C42.826 42.1281 42.7858 41.7846 42.5443 41.4007C42.3833 41.1986 42.0613 40.9157 41.6588 40.7743H41.699C42.2021 40.5723 42.987 39.9459 42.987 38.7336ZM40.6525 39.8247H40.572C40.3305 39.9661 40.0487 39.9661 39.6865 39.9661H37.513V38.2688H39.7267C40.0488 38.2688 40.3708 38.2688 40.6123 38.4103C40.8739 38.5315 41.0147 38.7942 41.0147 39.0973C41.0147 39.4206 40.894 39.663 40.6525 39.8247ZM54.4784 42.6534H50.9967V44.2698H54.4985C56.3097 44.2698 57.316 43.5222 57.316 41.8856C57.316 41.1178 57.1349 40.6733 56.8129 40.3096C56.4104 39.9459 55.7463 39.7842 54.8608 39.7438L53.8545 39.7034C53.5728 39.7034 53.3715 39.7034 53.1702 39.6226C52.9288 39.5418 52.7677 39.3397 52.7677 39.0569C52.7677 38.8144 52.808 38.6123 53.0093 38.4911C53.2306 38.3699 53.4923 38.3093 53.7338 38.3295H57.0343V36.713H53.4118C51.52 36.713 50.8358 37.8849 50.8358 38.976C50.8358 41.4007 52.9086 41.2794 54.6193 41.3199C54.901 41.3199 55.1023 41.3603 55.223 41.4815C55.3438 41.5623 55.4444 41.7644 55.4444 41.9664C55.4444 42.1685 55.3438 42.3705 55.2431 42.4513C55.0821 42.5928 54.8406 42.6332 54.4985 42.6332L54.4784 42.6534ZM0 0V27.1963L2.1735 22.1248H6.86263L7.46638 23.3775V22.1248H12.9404L14.1479 24.8727L15.3151 22.145H32.7635C33.5484 22.145 34.2528 22.3067 34.776 22.7916V22.1652H39.5859V22.7916C40.411 22.3269 41.4173 22.1652 42.5845 22.1652H49.5679L50.2119 23.4179V22.1652H55.3639L56.0481 23.4179V22.1652H61.0391V32.8134H55.9676L55.0016 31.197V32.773H48.6824L47.9981 31.0758H46.4284L45.7039 32.7326H42.4638C41.1758 32.7326 40.2098 32.4497 39.5658 32.086V32.7326H31.8176V30.3484C31.8176 30.0251 31.7371 30.0251 31.5359 29.9847H31.2541V32.773H16.261V31.4799L15.6975 32.773H12.5781L12.0347 31.4799V32.7326H5.97713L5.29288 31.0556H3.72313L3.03888 32.7326H0V64.657H63.8164V45.5023C63.0919 45.866 62.1661 45.9873 61.2001 45.9873H56.5714V45.3003C56.0079 45.7448 55.0419 45.9873 54.1161 45.9873H39.445V43.5626C39.445 43.2393 39.3846 43.2393 39.123 43.2393H38.9218V45.9873H34.0918V43.1181C33.2868 43.4818 32.361 43.5222 31.5963 43.4818H31.0328V45.9469H25.1965L23.7475 44.29L22.218 45.9065H12.719V35.3189H22.3991L23.7878 36.9353L25.277 35.3189H31.7371C32.5019 35.3189 33.7094 35.3997 34.2528 35.925V35.2785H40.089C40.6324 35.2785 41.8197 35.3997 42.5241 35.8846V35.2381H51.2785V35.8846C51.7212 35.4401 52.647 35.2381 53.4319 35.2381H58.5034V35.8846C59.0266 35.4805 59.7511 35.2381 60.7574 35.2381H63.917V0H0ZM56.7726 40.2894C56.7726 40.2894 56.7726 40.3298 56.7928 40.35C56.833 40.35 56.8733 40.35 56.8934 40.3904L56.7726 40.2894ZM63.9371 35.2381H64.1183V36.7332H63.9371V35.2381ZM64.0378 40.4914C64.0378 40.4914 63.917 40.35 63.8365 40.2894C63.434 39.8853 62.79 39.7034 61.7838 39.6832H60.8177C60.4958 39.663 60.3146 39.6226 60.0933 39.562C59.8518 39.4812 59.6908 39.2791 59.6908 38.9962C59.6908 38.7538 59.7713 38.5517 59.9323 38.4507C60.1335 38.3295 60.3348 38.3093 60.6567 38.3093H63.9371V36.7332H60.4958C58.6442 36.7332 57.9198 37.9052 57.9198 38.9962C57.9198 41.4209 60.0128 41.2996 61.7033 41.34C61.985 41.34 62.1862 41.3603 62.307 41.5017C62.4277 41.5825 62.5083 41.7846 62.5083 41.9866C62.5083 42.1685 62.4076 42.3503 62.2668 42.4715C62.146 42.613 61.9045 42.6534 61.5423 42.6534H58.0808V44.29H61.5423C62.6693 44.29 63.5145 43.9667 63.9573 43.3202H64.0378C64.2793 42.9565 64.4 42.512 64.4 41.9058C64.4 41.2592 64.2793 40.8551 64.0378 40.4914ZM49.91 38.2688V36.6928H43.9128V44.3304H49.91V42.7544H45.7039V41.239H49.8094V39.663H45.7039V38.2891H49.91V38.2688ZM36.2653 23.6604H38.0966V31.2576H36.2653V23.6604ZM35.2188 25.7011H35.1986C35.1986 24.8727 34.8565 24.3676 34.293 24.0443C33.7094 23.7008 33.0452 23.6806 32.1195 23.6806H27.9939V31.2778H29.8051V28.4895H31.7371C32.3811 28.4895 32.7836 28.5703 33.0452 28.8128C33.3673 29.1765 33.327 29.8432 33.327 30.2878V31.2576H35.1382V29.7826C35.1382 29.1158 35.098 28.7724 34.8364 28.3885C34.5949 28.1056 34.293 27.8833 33.9509 27.7621C34.4138 27.5802 35.2188 26.9539 35.2188 25.7416V25.7011ZM32.9245 26.772H32.8843C32.6427 26.9135 32.361 26.9337 31.9988 26.9337H29.785V25.2566H31.9988C32.3208 25.2566 32.6427 25.2566 32.8843 25.3981C33.1258 25.4991 33.2868 25.7416 33.2868 26.0648C33.2868 26.3881 33.166 26.6508 32.9245 26.7922V26.772ZM42.7254 25.2364H44.4159V23.62H42.6851C41.4575 23.62 40.5318 23.9029 39.9481 24.509C39.1834 25.3172 38.9821 26.3679 38.9821 27.4994C38.9821 28.8734 39.3041 29.7422 39.9481 30.3888C40.572 31.0353 41.6789 31.2374 42.5443 31.2374H44.6373L45.3215 29.5402H49.0446L49.749 31.2374H53.3916V25.5597L56.8129 31.2374H59.3688V23.6604H57.5173V28.9542L54.3576 23.6806H51.6206V30.7121L48.5817 23.5594H45.885L43.3694 29.5402H42.5644C42.1015 29.5402 41.5984 29.4593 41.3166 29.1765C40.9745 28.7724 40.8135 28.2066 40.8135 27.3984C40.8135 26.6306 41.0148 26.0244 41.3166 25.7011C41.6789 25.3375 42.0411 25.2566 42.7052 25.2566L42.7254 25.2364ZM47.2132 24.9536L48.4409 27.9641H45.9454L47.1931 24.9536H47.2132ZM6.39975 29.5402L7.084 31.2374H10.7468V25.297L13.363 31.2374H14.9328L17.549 25.297L17.5893 31.2374H19.4408V23.6806H16.4421L14.2887 28.8128L11.9341 23.6806H9.016V30.8535L5.957 23.6806H3.28038L0.04025 31.2576H1.97225L2.6565 29.5806H6.39975V29.5402ZM4.54825 24.9536L5.796 27.9641H3.34075L4.56838 24.9536H4.54825ZM31.8176 36.6928H26.082L23.7878 39.1781L21.574 36.6928H14.3491V44.29H21.4734L23.7676 41.7846L25.9814 44.29H29.463V41.7644H31.717C33.327 41.7644 34.8565 41.3198 34.8565 39.2185C34.8565 37.0969 33.2465 36.713 31.8176 36.6928ZM20.5879 42.714H16.1604V41.1986H20.1049V39.663H16.1604V38.2891H20.6684L22.6406 40.4914L20.5879 42.714ZM27.6719 43.603L24.8946 40.5116L27.6719 37.5415V43.603ZM31.8377 40.2086H29.463V38.2688H31.8377C32.4818 38.2688 32.9647 38.5315 32.9647 39.1983C32.9647 39.8651 32.5623 40.2086 31.8377 40.2086ZM26.7663 25.2364V23.6604H20.769V31.2576H26.7663V29.6816H22.54V28.1662H26.6455V26.6104H22.54V25.2364H26.7663Z" />
  </svg>
);

const CreditCard = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="lucide lucide-credit-card"
  >
    <rect width="20" height="14" x="2" y="5" rx="2" />
    <line x1="2" x2="22" y1="10" y2="10" />
  </svg>
);

const Paypal = (
  <svg
    width="100%"
    height="100%"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="7.056000232696533 3 37.35095977783203 45"
  >
    <g xmlns="http://www.w3.org/2000/svg" clipPath="url(#a)">
      <path
        className="fill-secondary-black dark:fill-secondary-gray4"
        d="M38.914 13.35c0 5.574-5.144 12.15-12.927 12.15H18.49l-.368 2.322L16.373 39H7.056l5.605-36h15.095c5.083 0 9.082 2.833 10.555 6.77a9.687 9.687 0 0 1 .603 3.58z"
      ></path>
      <path
        className="fill-secondary-gray1 dark:fill-secondary-gray2"
        d="M44.284 23.7A12.894 12.894 0 0 1 31.53 34.5h-5.206L24.157 48H14.89l1.483-9 1.75-11.178.367-2.322h7.497c7.773 0 12.927-6.576 12.927-12.15 3.825 1.974 6.055 5.963 5.37 10.35z"
      ></path>
      <path
        className="fill-secondary-gray4 dark:fill-secondary-gray1"
        fill="#787878"
        d="M38.914 13.35C37.31 12.511 35.365 12 33.248 12h-12.64L18.49 25.5h7.497c7.773 0 12.927-6.576 12.927-12.15z"
      ></path>
    </g>
  </svg>
);

const ApplePay = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 65 43"
  >
    <path d="M65.0001 5.75793C65.0001 5.57043 65.0001 5.38683 64.9923 5.19933C64.9806 4.79308 64.9573 4.38292 64.8873 3.98447C64.8133 3.57822 64.6966 3.19931 64.5099 2.82821C64.327 2.46493 64.0858 2.13289 63.7978 1.84382C63.5099 1.55476 63.1792 1.31257 62.8174 1.12897C62.4478 0.941471 62.0704 0.820376 61.6657 0.746156C61.265 0.675843 60.8564 0.648499 60.4557 0.640686C60.2689 0.63678 60.0861 0.632874 59.8993 0.632874C59.6814 0.632874 59.4596 0.632874 59.2379 0.632874H6.36622C6.14444 0.632874 5.92656 0.632874 5.70479 0.632874C5.51803 0.632874 5.33516 0.632874 5.14841 0.640686C4.74377 0.652405 4.33524 0.675843 3.93838 0.746156C3.53374 0.820376 3.15633 0.937564 2.78671 1.12897C2.42487 1.31257 2.09415 1.55476 1.80624 1.84382C1.51832 2.13289 1.27709 2.46493 1.09423 2.82821C0.907468 3.19931 0.786855 3.57822 0.716821 3.98447C0.642896 4.38682 0.619551 4.79308 0.607879 5.19933C0.603988 5.38683 0.600098 5.57043 0.600098 5.75793C0.600098 5.98059 0.600098 6.19934 0.600098 6.422V36.2348C0.600098 36.4575 0.600098 36.6762 0.600098 36.8989C0.600098 37.0864 0.600098 37.27 0.607879 37.4575C0.619551 37.8638 0.642896 38.27 0.716821 38.6724C0.790745 39.0786 0.907468 39.4575 1.09423 39.8286C1.27709 40.1919 1.51832 40.5239 1.80624 40.813C2.09415 41.1021 2.42487 41.3443 2.78671 41.5279C3.15633 41.7154 3.53374 41.8365 3.93838 41.9107C4.33913 41.981 4.74377 42.0083 5.14841 42.0161C5.33516 42.0201 5.51803 42.024 5.70479 42.024C5.92267 42.024 6.14444 42.024 6.36622 42.024H59.2301C59.448 42.024 59.6697 42.024 59.8915 42.024C60.0783 42.024 60.2611 42.024 60.4479 42.0161C60.8525 42.0044 61.2572 41.981 61.6579 41.9107C62.0626 41.8365 62.44 41.7193 62.8096 41.5279C63.1714 41.3443 63.5022 41.1021 63.7901 40.813C64.078 40.5239 64.3192 40.1919 64.5021 39.8286C64.6888 39.4575 64.8095 39.0786 64.8795 38.6724C64.9534 38.27 64.9768 37.8638 64.9845 37.4575C64.9884 37.27 64.9923 37.0864 64.9923 36.8989C64.9923 36.6762 64.9923 36.4575 64.9923 36.2348V6.41809C64.9923 6.19544 64.9923 5.97668 64.9923 5.75402L65.0001 5.75793ZM63.6267 36.2309C63.6267 36.4497 63.6267 36.6645 63.6267 36.8872C63.6267 37.063 63.6267 37.2387 63.6189 37.4145C63.6111 37.727 63.5955 38.0864 63.5333 38.4263C63.4827 38.7192 63.401 38.9614 63.2843 39.1958C63.1637 39.4302 63.0119 39.645 62.8252 39.8325C62.6384 40.02 62.4283 40.1763 62.191 40.2935C61.9575 40.4146 61.7124 40.4927 61.4245 40.5474C61.0821 40.6099 60.7047 40.6255 60.4246 40.6333C60.2456 40.6372 60.0705 40.6411 59.8876 40.6411C59.6697 40.6411 59.4558 40.6411 59.2379 40.6411H6.35844C6.14444 40.6411 5.93045 40.6411 5.71257 40.6411C5.53359 40.6411 5.35851 40.6411 5.18731 40.6333C4.8994 40.6255 4.52199 40.6099 4.1835 40.5474C3.89169 40.4966 3.64657 40.4146 3.40923 40.2935C3.17579 40.1763 2.96568 40.02 2.77893 39.8325C2.59217 39.645 2.44043 39.4341 2.31982 39.1997C2.1992 38.9653 2.12139 38.7192 2.06692 38.4224C2.00467 38.0864 1.9891 37.7231 1.98132 37.4145C1.97743 37.2387 1.97354 37.063 1.97354 36.8872V36.3676V36.2309V6.28137V5.76184C1.97354 5.58605 1.97354 5.41027 1.98132 5.23058C1.9891 4.92198 2.00467 4.5587 2.06692 4.21885C2.1175 3.92588 2.1992 3.67978 2.31982 3.4454C2.43654 3.21103 2.59217 3.00009 2.77893 2.81259C2.96568 2.62508 3.17579 2.47274 3.40923 2.35164C3.64268 2.23055 3.8878 2.15242 4.1796 2.09773C4.51421 2.03523 4.87605 2.01961 5.18342 2.0118C5.35851 2.00789 5.53748 2.00398 5.70868 2.00398H6.36233H59.2262H59.876C60.051 2.00398 60.23 2.00789 60.4051 2.0118C60.7125 2.01961 61.0743 2.03523 61.4089 2.09773C61.7007 2.15242 61.9458 2.23055 62.1793 2.35164C62.4127 2.46883 62.6228 2.62508 62.8096 2.81259C62.9964 3.00009 63.152 3.21493 63.2687 3.44931C63.3893 3.68369 63.4671 3.92979 63.5177 4.22276C63.5761 4.55479 63.5955 4.91808 63.6033 5.23058C63.6072 5.40636 63.6111 5.58215 63.6111 5.76184C63.6111 5.98059 63.6111 6.19544 63.6111 6.41419V36.227L63.6267 36.2309ZM15.7974 15.6799C15.6807 14.7697 16.132 13.801 16.6456 13.2072C17.2176 12.5158 18.2019 12.0197 19.0073 11.9807C19.1046 12.9299 18.7311 13.8596 18.1786 14.5549C17.6066 15.2268 16.7001 15.7619 15.7974 15.6838V15.6799ZM22.3378 23.7659C22.3184 23.8245 22.0032 24.9105 21.2367 26.0355C20.5675 27.0238 19.8827 27.9886 18.7817 28.0082C17.7195 28.0277 17.3693 27.3754 16.1515 27.3754C14.9337 27.3754 14.5407 27.9886 13.5408 28.0277C12.4786 28.0668 11.6771 26.9808 11.0079 25.9964C9.63446 24.0042 8.59174 20.3753 10.008 17.926C10.6966 16.7034 11.9534 15.9338 13.3073 15.9143C14.3501 15.8948 15.3111 16.6057 15.9375 16.6057C16.5639 16.6057 17.6845 15.7776 18.9995 15.8557C19.5092 15.8948 20.9838 16.0549 21.9254 17.4534C21.8476 17.512 20.1784 18.4807 20.1979 20.512C20.2174 22.9378 22.3184 23.7464 22.3378 23.7659ZM30.454 13.1057H24.9291V27.9027H27.2168V22.848H30.3839C33.2748 22.848 35.3058 20.8597 35.3058 17.9651C35.3058 15.0705 33.3137 13.1057 30.454 13.1057ZM29.8431 20.9222H27.2168V15.0471H29.8509C31.8313 15.0471 32.9674 16.1135 32.9674 17.9807C32.9674 19.8479 31.8352 20.9222 29.8431 20.9222ZM40.7684 16.9221C38.111 16.9221 36.4574 18.3596 36.3368 20.305H38.4223C38.6168 19.3401 39.4144 18.7268 40.6906 18.7268C42.0368 18.7268 42.8461 19.4456 42.8461 20.6448V21.4769L39.9046 21.6526C37.3523 21.7972 35.9088 22.9534 35.9088 24.8441C35.9088 26.7347 37.3795 28.0941 39.4844 28.0941C40.8929 28.0941 42.2508 27.3363 42.8772 26.1371H42.9278V27.9105H45.0405V20.4768C45.0405 18.3128 43.3752 16.9299 40.7723 16.9299L40.7684 16.9221ZM42.8422 23.8636C42.8422 25.2699 41.636 26.3363 40.0953 26.3363C38.9086 26.3363 38.1343 25.7191 38.1343 24.7777C38.1343 23.8363 38.8814 23.2698 40.1964 23.1761L42.8422 23.012V23.8636ZM53.8375 17.1174H56.1681L52.145 28.4691C51.2268 31.0863 50.1646 31.9262 47.9352 31.9262C47.7523 31.9262 47.1998 31.9067 47.0364 31.8754V30.0824C47.1998 30.1215 47.5656 30.1215 47.7523 30.1215C48.7756 30.1215 49.3242 29.6918 49.6627 28.5824C49.6627 28.5629 49.8572 27.9261 49.8572 27.9144L45.9742 17.1135H48.3632L51.0789 25.891H51.1178L53.8336 17.1135L53.8375 17.1174Z" />
  </svg>
);

const GooglePay = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 65 35"
  >
    <path d="M47.6722 0.132538H17.5276C8.10735 0.132538 0.399902 7.87074 0.399902 17.3285C0.399902 26.7863 8.10735 34.5245 17.5276 34.5245H47.6722C57.0925 34.5245 64.7999 26.7863 64.7999 17.3285C64.7999 7.87074 57.0925 0.132538 47.6722 0.132538ZM58.7881 28.4887C57.3408 29.9418 55.6537 31.0853 53.7783 31.885C51.8428 32.7104 49.7875 33.1317 47.6722 33.1317H17.5276C15.4123 33.1317 13.357 32.7104 11.4216 31.885C9.54607 31.0853 7.86756 29.9418 6.41171 28.4887C4.96442 27.0357 3.82543 25.3419 3.029 23.4589C2.20687 21.5158 1.78724 19.4522 1.78724 17.3285C1.78724 15.2048 2.20687 13.1413 3.029 11.1982C3.82543 9.3152 4.96442 7.62999 6.41171 6.16833C7.859 4.71527 9.54607 3.57174 11.4216 2.77212C13.357 1.94672 15.4123 1.52541 17.5276 1.52541H47.6722C49.7875 1.52541 51.8428 1.94672 53.7783 2.77212C55.6537 3.57174 57.3322 4.71527 58.7881 6.16833C60.2354 7.6214 61.3744 9.3152 62.1708 11.1982C62.9929 13.1413 63.4126 15.2048 63.4126 17.3285C63.4126 19.4522 62.9929 21.5158 62.1708 23.4589C61.3744 25.3419 60.2354 27.0271 58.7881 28.4887ZM36.642 12.015C35.8713 11.2755 34.9293 10.9058 33.8245 10.9058H29.4655V23.7512H31.1098V18.5409H33.8245C34.9378 18.5409 35.8799 18.1797 36.642 17.4489C37.4299 16.7181 37.8238 15.8153 37.8238 14.7233C37.8238 13.6314 37.4299 12.7544 36.642 12.015ZM35.4859 16.3054C35.0577 16.7439 34.5096 16.9674 33.8588 16.9674H31.1098V12.4965H33.8588C34.5182 12.4965 35.0577 12.72 35.4859 13.1757C35.9227 13.6142 36.1453 14.1387 36.1453 14.7319C36.1453 15.3252 35.9227 15.8669 35.4859 16.3054ZM45.0003 15.6519C44.2981 14.9985 43.3389 14.6718 42.1229 14.6718C40.5643 14.6718 39.3825 15.2478 38.586 16.4086L40.0333 17.3199C40.5643 16.5375 41.2922 16.1506 42.2085 16.1506C42.8166 16.1506 43.3475 16.3484 43.8014 16.7525C44.2553 17.1566 44.4779 17.6381 44.4779 18.2141V18.5924C43.8528 18.2313 43.0478 18.0508 42.0715 18.0508C40.9325 18.0508 40.0162 18.3173 39.3311 18.859C38.646 19.3921 38.3034 20.1143 38.3034 21.0257C38.3034 21.8855 38.6288 22.5991 39.2797 23.1752C39.9305 23.7512 40.7355 24.035 41.7033 24.035C42.8337 24.035 43.7414 23.5363 44.418 22.5303H44.4865V23.7512H46.0537V18.3345C46.0537 17.1996 45.7026 16.3054 45.0003 15.6519ZM43.6729 21.7823C43.1334 22.2982 42.5168 22.5561 41.8232 22.5561C41.335 22.5561 40.9068 22.41 40.5471 22.1262C40.1789 21.8425 39.9991 21.4814 39.9991 21.0515C39.9991 20.5786 40.2217 20.1745 40.6756 19.8392C41.1209 19.521 41.6776 19.3577 42.3455 19.3577C43.2619 19.3577 43.9727 19.564 44.4865 19.9681C44.4865 20.6646 44.2125 21.2664 43.6729 21.7823ZM53.2045 14.9555H54.9943L49.5135 27.6117H47.8178L49.856 23.1838L46.2421 14.9555H48.0319L50.6353 21.2664H50.6696L53.2045 14.9555ZM24.4326 15.952C24.5216 16.4472 24.5696 16.9623 24.5696 17.5005C24.5696 19.7394 23.7792 21.6344 22.3995 22.9164C21.1877 24.0419 19.5238 24.6962 17.5421 24.6962C14.675 24.6962 12.194 23.0454 10.9857 20.6405C10.4872 19.6457 10.2055 18.5228 10.2055 17.3328C10.2055 16.1429 10.4864 15.02 10.9857 14.0252C12.1932 11.6195 14.6758 9.96865 17.5421 9.96865C19.5212 9.96865 21.1792 10.6986 22.4509 11.8877L20.3571 13.9882C19.5923 13.2574 18.6237 12.8834 17.5421 12.8834C15.6281 12.8834 14.0044 14.1782 13.4229 15.9236C13.2748 16.369 13.1934 16.8428 13.1934 17.3328C13.1934 17.8229 13.2748 18.2958 13.4229 18.7412C14.0044 20.4866 15.6281 21.7814 17.5421 21.7814C18.533 21.7814 19.3791 21.5209 20.0368 21.0764C20.8306 20.539 21.3487 19.7343 21.5097 18.7902H17.5404V15.952H24.4326Z" />
  </svg>
);

const AmazonPay = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 65 41"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M58.4115 32.5142C51.3605 37.7386 41.1392 40.5164 32.3364 40.5164C19.9997 40.5164 8.89072 35.9377 0.484853 28.3172C-0.175022 27.7186 0.412837 26.9014 1.2067 27.3655C10.2758 32.6639 21.492 35.8553 33.0767 35.8553C40.8913 35.8553 49.4814 34.2277 57.3865 30.8613C58.5773 30.3518 59.5772 31.6483 58.4115 32.5142ZM61.3441 29.1512C62.2468 30.3115 60.3409 35.0886 59.4901 37.2224C59.2322 37.8681 59.7848 38.1287 60.3677 37.6394C64.1494 34.4631 65.1275 27.806 64.3537 26.8442C63.585 25.8908 56.9728 25.0702 52.9365 27.9153C52.3152 28.3525 52.4224 28.9579 53.1107 28.8738C55.3834 28.6014 60.443 27.991 61.3441 29.1512ZM51.1361 20.5975L58.4751 1.84379C58.6292 1.46378 58.7079 1.19642 58.7079 1.04004C58.7079 0.772683 58.5522 0.638164 58.2407 0.638164H56.3733C56.0165 0.638164 55.7737 0.695334 55.638 0.806313C55.504 0.918973 55.3717 1.16447 55.2377 1.54449L50.7342 14.5374L46.0648 1.54449C45.9308 1.16447 45.7985 0.918973 45.6645 0.806313C45.5305 0.695334 45.286 0.638164 44.9293 0.638164H42.9279C42.6164 0.638164 42.4606 0.772683 42.4606 1.04004C42.4606 1.19642 42.5377 1.46378 42.6934 1.84379L49.1314 17.7843L48.4983 19.4927C48.1198 20.5655 47.6977 21.302 47.2305 21.7039C46.7632 22.1058 46.1067 22.3059 45.2626 22.3059C44.8841 22.3059 44.5843 22.2823 44.3632 22.2386C44.1404 22.1949 43.973 22.1714 43.8624 22.1714C43.5291 22.1714 43.3617 22.3832 43.3617 22.807V23.678C43.3617 23.9907 43.4169 24.2194 43.5291 24.364C43.6397 24.5086 43.8172 24.6162 44.0634 24.6818C44.6178 24.8365 45.2525 24.9172 45.9643 24.9172C47.2321 24.9172 48.2605 24.5826 49.0493 23.9117C49.8415 23.2442 50.5365 22.1377 51.1361 20.5975ZM23.7396 5.24714C23.4163 4.16425 22.9558 3.2428 22.3545 2.48444C21.7549 1.72609 21.0214 1.14429 20.1538 0.742416C19.2879 0.340539 18.3199 0.140442 17.2514 0.140442C16.2515 0.140442 15.2717 0.328769 14.3171 0.708786C13.3608 1.0888 12.4597 1.64706 11.614 2.38355L11.4482 1.31076C11.3812 0.865165 11.1249 0.641527 10.6794 0.641527H9.21229C8.76846 0.641527 8.54571 0.865165 8.54571 1.31076V23.8495C8.54571 24.2968 8.76846 24.5187 9.21229 24.5187H11.1802C11.6257 24.5187 11.8468 24.2951 11.8468 23.8495V16.0137C13.2921 17.3303 15.0155 17.9895 17.0169 17.9895C18.1055 17.9895 19.0953 17.7709 19.9847 17.3371C20.874 16.9016 21.6293 16.2929 22.2524 15.511C22.8754 14.7308 23.3594 13.7824 23.7027 12.6642C24.0478 11.5477 24.2203 10.2967 24.2203 8.91279C24.2236 7.55246 24.0612 6.33002 23.7396 5.24714ZM16.2515 15.3092C14.7375 15.3092 13.2704 14.7745 11.8484 13.7017V4.35931C13.2486 3.33191 14.7392 2.81906 16.3185 2.81906C19.3432 2.81906 20.8556 4.90747 20.8556 9.08094C20.8556 13.2342 19.3198 15.3092 16.2515 15.3092ZM38.7811 1.45537C37.7795 0.586037 36.2236 0.150531 34.1117 0.150531C33.0666 0.150531 32.0215 0.246376 30.9764 0.434703C29.9297 0.624712 29.0521 0.875254 28.3403 1.18801C28.074 1.30067 27.8948 1.41669 27.806 1.53944C27.7173 1.66219 27.672 1.88079 27.672 2.19186V3.09482C27.672 3.4967 27.8161 3.69848 28.1058 3.69848C28.1946 3.69848 28.29 3.68167 28.3905 3.64804C28.491 3.61441 28.5748 3.5875 28.6401 3.56396C30.3534 3.05111 31.9863 2.79384 33.5439 2.79384C34.8771 2.79384 35.8116 3.03934 36.3459 3.53201C36.8801 4.02301 37.1464 4.87048 37.1464 6.07611V8.28559C35.5905 7.90557 34.1887 7.71725 32.9427 7.71725C30.9865 7.71725 29.4306 8.2032 28.2733 9.17342C27.1177 10.1436 26.5382 11.4451 26.5382 13.0745C26.5382 14.5946 27.0055 15.8035 27.94 16.7082C28.8729 17.6128 30.1407 18.0635 31.7418 18.0635C32.6981 18.0635 33.6595 17.8735 34.6275 17.4951C35.5956 17.1168 36.4782 16.5787 37.2787 15.8876L37.4462 16.9924C37.5132 17.4161 37.7577 17.628 38.1815 17.628H39.6151C40.0589 17.628 40.2834 17.4043 40.2834 16.9587V5.50777C40.2834 3.67662 39.7809 2.32638 38.7811 1.45537ZM37.1464 13.848C36.4129 14.4062 35.6458 14.83 34.8452 15.1209C34.0447 15.4118 33.2776 15.5564 32.5441 15.5564C31.6765 15.5564 31.0099 15.3277 30.5427 14.8703C30.0754 14.413 29.8426 13.7605 29.8426 12.9114C29.8426 10.9693 31.0987 9.99735 33.6109 9.99735C34.1887 9.99735 34.7833 10.0377 35.3946 10.1151C36.0059 10.1941 36.5904 10.3 37.1464 10.4329V13.848Z"
    />
  </svg>
);

const Facebook = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 18 32"
    fill="none"
  >
    <path d="M17.3339 14.1276L16.9286 17.3561C16.8601 17.8954 16.3998 18.3011 15.8537 18.3011H10.5832V31.7994C10.0274 31.8492 9.46426 31.8748 8.89498 31.8748C7.62174 31.8748 6.3791 31.7484 5.17809 31.5079V18.3011H1.12453C0.75235 18.3011 0.44873 17.9987 0.44873 17.6282V13.5883C0.44873 13.2179 0.75235 12.9154 1.12453 12.9154H5.17809V6.85679C5.17809 3.13877 8.20326 0.125244 11.9361 0.125244H16.6654C17.0376 0.125244 17.3412 0.42769 17.3412 0.798155V4.83805C17.3412 5.20852 17.0376 5.51096 16.6654 5.51096H13.2864C11.7941 5.51096 10.5845 6.71589 10.5845 8.20382V12.9166H16.2602C16.9115 12.9166 17.4147 13.4851 17.3351 14.1288L17.3339 14.1276Z" />
  </svg>
);

const Instagram = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 33 32"
    fill="none"
  >
    <path d="M24.6197 0.125854H8.06778C3.80275 0.125854 0.34375 3.55765 0.34375 7.78913V24.2109C0.34375 28.4424 3.80275 31.8742 8.06778 31.8742H24.6197C28.8847 31.8742 32.3438 28.4424 32.3438 24.2109V7.78913C32.3438 3.55765 28.8847 0.125854 24.6197 0.125854ZM29.5848 23.6625C29.5848 26.6846 27.113 29.1369 24.067 29.1369H8.61895C5.57294 29.1369 3.10113 26.6846 3.10113 23.6625V8.33597C3.10113 5.31391 5.57294 2.86154 8.61895 2.86154H24.067C27.113 2.86154 29.5848 5.31391 29.5848 8.33597V23.6625ZM16.3599 7.78913C11.7924 7.78913 8.08467 11.4677 8.08467 15.9992C8.08467 20.5308 11.7924 24.2094 16.3599 24.2094C20.9274 24.2094 24.6351 20.5308 24.6351 15.9992C24.6351 11.4677 20.9274 7.78913 16.3599 7.78913ZM16.3599 21.4737C13.32 21.4737 10.842 19.0152 10.842 15.9992C10.842 12.9833 13.32 10.5248 16.3599 10.5248C19.3997 10.5248 21.8777 12.9833 21.8777 15.9992C21.8777 19.0152 19.3997 21.4737 16.3599 21.4737ZM25.1862 8.88432C24.2743 8.88432 23.5312 8.14709 23.5312 7.2423C23.5312 6.33751 24.2743 5.60028 25.1862 5.60028C26.0982 5.60028 26.8413 6.33751 26.8413 7.2423C26.8413 8.14709 26.0982 8.88432 25.1862 8.88432Z" />
  </svg>
);

const Twitter = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 37 32"
    fill="none"
  >
    <path d="M22.6085 13.2194L34.9476 0.125854H30.2619L20.5773 10.4045L13.1603 0.125854H0.34375L13.3169 18.1058L0.34375 31.8742H5.02945L15.3497 20.9223L23.2518 31.8742H36.0684L22.6085 13.2209V13.2194ZM6.94702 3.49368H11.4147L29.4636 28.5063H24.9959L6.94702 3.49368Z" />
  </svg>
);

const TikTok = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 27 32"
    fill="none"
  >
    <path d="M18.827 23.1166V9.43252C18.827 9.43252 20.3822 12.0042 26.0034 12.1613C26.3033 12.1696 26.5513 11.9249 26.5513 11.6275V7.76024C26.5513 7.47249 26.3201 7.24451 26.0301 7.22783C21.6698 6.98318 19.599 3.66503 19.3958 0.622117C19.3776 0.339929 19.1282 0.125854 18.8438 0.125854H14.398C14.1024 0.125854 13.8614 0.36356 13.8614 0.658259V22.4118C13.8614 24.775 12.0414 26.8309 9.66228 26.9421C6.94272 27.07 4.73176 24.7541 5.06803 22.017C5.30622 20.0834 6.86986 18.5001 8.8146 18.2318C9.20131 18.179 9.57821 18.1748 9.9439 18.2151C10.2676 18.2513 10.552 18.0122 10.552 17.6897V13.8127C10.552 13.5375 10.3404 13.2984 10.063 13.2817C9.50535 13.2455 8.9337 13.258 8.35364 13.3234C4.06483 13.8071 0.602685 17.2504 0.127708 21.5068C-0.498589 27.1214 3.91491 31.8742 9.44791 31.8742C14.6278 31.8742 18.827 27.708 18.827 22.5689" />
  </svg>
);

const Linkedin = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      id="Linkedin"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M26.6667 30H3.33333C1.49238 30 0 28.5076 0 26.6667V3.33333C0 1.49238 1.49238 0 3.33333 0H26.6667C28.5076 0 30 1.49238 30 3.33333V26.6667C30 28.5076 28.5076 30 26.6667 30ZM21.3815 25.8333H25.8333V16.688C25.8333 12.8185 23.6399 10.9476 20.5761 10.9476C17.5109 10.9476 16.2209 13.3346 16.2209 13.3346V11.3889H11.9306V25.8333H16.2209V18.2509C16.2209 16.2192 17.1561 15.0102 18.9461 15.0102C20.5916 15.0102 21.3815 16.172 21.3815 18.2509V25.8333ZM4.16667 6.83209C4.16667 8.30402 5.35086 9.49751 6.81223 9.49751C8.2736 9.49751 9.45708 8.30402 9.45708 6.83209C9.45708 5.36015 8.2736 4.16667 6.81223 4.16667C5.35086 4.16667 4.16667 5.36015 4.16667 6.83209ZM9.07058 25.8333H4.5969V11.3889H9.07058V25.8333Z"
    />
  </svg>
);

const Youtube = (
  <svg
    width="100%"
    height="150%"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="100 100 400 450"
  >
    <path d="M490.96,162.49c-4.64-17.09-17.67-30.41-35.05-35.05-30.7-8.4-154.96-8.4-154.96-8.4,0,0-123.97,0-154.67,8.4-17.09,4.63-30.41,17.96-35.34,35.05-8.11,30.7-8.11,95.29-8.11,95.29,0,0,0,64.59,8.11,95.59,4.92,16.8,18.25,30.41,35.34,35.05,30.7,8.4,154.67,8.4,154.67,8.4,0,0,124.26,0,154.96-8.4,17.38-4.63,30.41-18.25,35.05-35.05,8.4-30.99,8.4-95.59,8.4-95.59,0,0,0-64.59-8.4-95.29ZM261.56,317.46v-119.05l102.83,59.38-102.83,59.67Z" />
  </svg>
);

const Whatsapp = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 28">
    <path
      className="st2"
      d="M20.46-48.54c-.35-.19-2.09-1.13-2.41-1.26-.33-.13-.56-.2-.82.15-.25.35-.97,1.13-1.19,1.37-.41.44-1.22-.14-1.67-.39-.52-.29-1.2-.73-1.94-1.44-1.03-.99-1.71-2.2-1.91-2.57-.3-.56.75-1.22,1.07-1.82.02-.03.04-.07.06-.11.13-.24.08-.45,0-.63-.08-.18-.74-1.98-1.01-2.71-.35-.93-1.88-.85-2.45-.27-.34.35-1.3,1.18-1.37,2.95-.07,1.77,1.16,3.53,1.33,3.77.17.25,2.34,4.08,5.94,5.66,2.13.93,3.83,1.8,5.88.4.4-.27.75-.61.89-.96.33-.83.36-1.55.27-1.7-.08-.15-.32-.25-.67-.45Z"
    />
    <path
      className="st2"
      d="M23.88-61.61c-2.62-2.62-6.1-4.07-9.82-4.07-7.65,0-13.88,6.22-13.88,13.87,0,2.45.64,4.83,1.85,6.94L.06-37.68l7.36-1.93c2.03,1.11,4.31,1.69,6.63,1.69h0s0,0,0,0c7.65,0,13.88-6.22,13.88-13.87,0-3.71-1.44-7.19-4.06-9.82h0ZM14.06-40.26h0c-2.07,0-4.1-.56-5.87-1.61l-.42-.25-4.37,1.14,1.17-4.26-.27-.44c-1.15-1.84-1.76-3.96-1.76-6.14,0-6.36,5.18-11.53,11.54-11.53,3.08,0,5.98,1.2,8.16,3.38,2.18,2.18,3.38,5.08,3.38,8.16,0,6.36-5.18,11.53-11.54,11.53Z"
    />
    <path
      className="st1"
      d="M20.46-15.7c-.35-.19-2.09-1.13-2.41-1.26-.33-.13-.56-.2-.82.15-.25.35-.97,1.13-1.19,1.37-.41.44-1.22-.14-1.67-.39-.52-.29-1.2-.73-1.94-1.44-1.03-.99-1.71-2.2-1.91-2.57-.3-.56.75-1.22,1.07-1.82.02-.03.04-.07.06-.11.13-.24.08-.45,0-.63-.08-.18-.74-1.98-1.01-2.71-.35-.93-1.88-.85-2.45-.27-.34.35-1.3,1.18-1.37,2.95-.07,1.77,1.16,3.53,1.33,3.77.17.25,2.34,4.08,5.94,5.66,2.13.93,3.83,1.8,5.88.4.4-.27.75-.61.89-.96.33-.83.36-1.55.27-1.7-.08-.15-.32-.25-.67-.45Z"
    />
    <path
      className="st1"
      d="M23.88-28.77c-2.62-2.62-6.1-4.07-9.82-4.07C6.41-32.84.18-26.61.18-18.96c0,2.45.64,4.83,1.85,6.94L.06-4.84l7.36-1.93c2.03,1.11,4.31,1.69,6.63,1.69h0s0,0,0,0c7.65,0,13.88-6.22,13.88-13.87,0-3.71-1.44-7.19-4.06-9.82h0ZM14.06-7.42h0c-2.07,0-4.1-.56-5.87-1.61l-.42-.25-4.37,1.14,1.17-4.26-.27-.44c-1.15-1.84-1.76-3.96-1.76-6.14,0-6.36,5.18-11.53,11.54-11.53,3.08,0,5.98,1.2,8.16,3.38,2.18,2.18,3.38,5.08,3.38,8.16,0,6.36-5.18,11.53-11.54,11.53Z"
    />
    <path
      className="st0"
      d="M20.46,17.14c-.35-.19-2.09-1.13-2.41-1.26-.33-.13-.56-.2-.82.15-.25.35-.97,1.13-1.19,1.37-.41.44-1.22-.14-1.67-.39-.52-.29-1.2-.73-1.94-1.44-1.03-.99-1.71-2.2-1.91-2.57-.3-.56.75-1.22,1.07-1.82.02-.03.04-.07.06-.11.13-.24.08-.45,0-.63-.08-.18-.74-1.98-1.01-2.71-.35-.93-1.88-.85-2.45-.27-.34.35-1.3,1.18-1.37,2.95-.07,1.77,1.16,3.53,1.33,3.77.17.25,2.34,4.08,5.94,5.66,2.13.93,3.83,1.8,5.88.4.4-.27.75-.61.89-.96.33-.83.36-1.55.27-1.7-.08-.15-.32-.25-.67-.45Z"
    />
    <path
      className="st0"
      d="M23.88,4.07C21.26,1.45,17.77,0,14.06,0,6.41,0,.18,6.22.18,13.87c0,2.45.64,4.83,1.85,6.94L.06,28l7.36-1.93c2.03,1.11,4.31,1.69,6.63,1.69h0s0,0,0,0c7.65,0,13.88-6.22,13.88-13.87,0-3.71-1.44-7.19-4.06-9.82h0ZM14.06,25.42h0c-2.07,0-4.1-.56-5.87-1.61l-.42-.25-4.37,1.14,1.17-4.26-.27-.44c-1.15-1.84-1.76-3.96-1.76-6.14,0-6.36,5.18-11.53,11.54-11.53,3.08,0,5.98,1.2,8.16,3.38,2.18,2.18,3.38,5.08,3.38,8.16,0,6.36-5.18,11.53-11.54,11.53Z"
    />
  </svg>
);

const Square = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M1.10059 18.8277V0.9375H18.9908V18.8277H1.10059Z"
      strokeWidth="1.875"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const Squares = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="30 0 20 20"
    fill="none"
  >
    <path
      d="M31.1724 7.75815V0.9375H37.993V7.75815H31.1724Z"
      strokeWidth="1.875"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M31.1724 19.0625V12.2419H37.993V19.0625H31.1724Z"
      strokeWidth="1.875"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M42.2419 19.019V12.1983H49.0626V19.019H42.2419Z"
      strokeWidth="1.875"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M42.2419 7.75815V0.9375H49.0626V7.75815H42.2419Z"
      strokeWidth="1.875"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const Warning = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 27 22"
    fill="none"
  >
    <path
      d="M26.0505 18.9062L15.2185 1.03125C14.3892 -0.34375 12.2964 -0.34375 11.4616 1.03125L0.634618 18.9062C-0.198732 20.2763 0.839224 22 2.50953 22H24.1736C25.8372 22 26.8783 20.2812 26.0505 18.9062ZM12.1207 6.67857C12.1207 6.0279 12.6667 5.5 13.3395 5.5C14.0124 5.5 14.5583 6.03036 14.5583 6.67857V12.9643C14.5583 13.615 14.0124 14.1429 13.3852 14.1429C12.7581 14.1429 12.1207 13.6174 12.1207 12.9643V6.67857ZM13.3395 18.8571C12.4579 18.8571 11.7429 18.1657 11.7429 17.3132C11.7429 16.4607 12.4574 15.7693 13.3395 15.7693C14.2216 15.7693 14.9361 16.4607 14.9361 17.3132C14.9341 18.1647 14.2232 18.8571 13.3395 18.8571Z"
      fill="#F5B206"
    />
  </svg>
);

const ArrowDown = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 17 11"
    fill="none"
  >
    <path
      d="M1 0.999999L8.5 10L16 1"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ArrowUpDown = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 11 18"
    fill="none"
  >
    <path
      d="M1.00002 11.9092L5.50001 17.0001L10 11.9092"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.99998 6.09082L5.49999 0.999911L1 6.09082"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ArrowOutlineUp = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
  >
    <path
      d="M14 20.1364L14 7.86363M14 7.86363L7.45508 14.4091M14 7.86363L20.5455 14.4091M14 2C20.6274 2 26 7.37258 26 14C26 20.6274 20.6274 26 14 26C7.37258 26 2 20.6274 2 14C2 7.37258 7.37258 2 14 2Z"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ArrowOutlineDown = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
  >
    <path
      d="M14 7.86364L14 20.1364M14 20.1364L20.5449 13.5909M14 20.1364L7.45454 13.5909M14 26C7.37258 26 2 20.6274 2 14C2 7.37258 7.37258 2 14 2C20.6274 2 26 7.37258 26 14C26 20.6274 20.6274 26 14 26Z"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const Download = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 12 13"
    fill="none"
  >
    <path
      d="M8.38 5.92836L6 8.31074M6 8.31074L3.62 5.92836M6 8.31074V1.63403M11 8.91132V11.1836C11 11.4338 10.79 11.634 10.55 11.634H1.44C1.19 11.634 1 11.4338 1 11.1836V8.91132"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const Filters = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 13 13"
    fill="none"
  >
    <path
      d="M1 9.92357H2.98001M6.99498 9.92357H12M12 3.34462H10.02M6.00502 3.34462H1M6.63203 9.92351C6.63203 10.8682 5.86374 11.634 4.91602 11.634C3.96829 11.634 3.20001 10.8682 3.20001 9.92351C3.20001 8.97881 3.96829 8.21298 4.91602 8.21298C5.86374 8.21298 6.63203 8.97881 6.63203 9.92351ZM9.80005 3.34456C9.80005 4.28926 9.03177 5.05509 8.08404 5.05509C7.13631 5.05509 6.36803 4.28926 6.36803 3.34456C6.36803 2.39986 7.13631 1.63403 8.08404 1.63403C9.03177 1.63403 9.80005 2.39986 9.80005 3.34456Z"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const Filters2 = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.2891 5C12.8589 5 11.6561 6.02518 11.3787 7.37666H3.59417C3.26602 7.37666 3 7.64268 3 7.97083C3 8.29897 3.26602 8.56499 3.59417 8.56499H11.3787C11.6561 9.91647 12.8589 10.9417 14.2891 10.9417C15.7194 10.9417 16.9222 9.91647 17.1996 8.56499H19.0425C19.3706 8.56499 19.6366 8.29897 19.6366 7.97083C19.6366 7.64268 19.3706 7.37666 19.0425 7.37666H17.1996C16.9222 6.02518 15.7194 5 14.2891 5ZM14.2891 6.18833C15.2806 6.18833 16.0716 6.97936 16.0716 7.97083C16.0716 8.96229 15.2806 9.75332 14.2891 9.75332C13.2977 9.75332 12.5066 8.96229 12.5066 7.97083C12.5066 6.97936 13.2977 6.18833 14.2891 6.18833Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.34749 10.9417C6.91722 10.9417 5.71441 11.9668 5.43701 13.3183H3.59417C3.26602 13.3183 3 13.5843 3 13.9125C3 14.2406 3.26602 14.5066 3.59417 14.5066H5.43701C5.71441 15.8581 6.91722 16.8833 8.34749 16.8833C9.77775 16.8833 10.9806 15.8581 11.258 14.5066H19.0425C19.3706 14.5066 19.6366 14.2406 19.6366 13.9125C19.6366 13.5843 19.3706 13.3183 19.0425 13.3183H11.258C10.9806 11.9668 9.77775 10.9417 8.34749 10.9417ZM8.34749 12.13C9.33895 12.13 10.13 12.921 10.13 13.9125C10.13 14.9039 9.33895 15.695 8.34749 15.695C7.35602 15.695 6.56499 14.9039 6.56499 13.9125C6.56499 12.921 7.35602 12.13 8.34749 12.13Z"
      fill="white"
    />
  </svg>
);

const Info = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 18 18"
    fill="none"
  >
    <path
      d="M6.89099 12.06C6.61485 12.06 6.39099 12.2839 6.39099 12.56C6.39099 12.8361 6.61485 13.06 6.89099 13.06V12.06ZM11.111 13.06C11.3871 13.06 11.611 12.8361 11.611 12.56C11.611 12.2839 11.3871 12.06 11.111 12.06V13.06ZM8.50097 11.88C8.50097 12.1561 8.72483 12.38 9.00097 12.38C9.27711 12.38 9.50097 12.1561 9.50097 11.88H8.50097ZM9.00097 8.57001H9.50097C9.50097 8.29386 9.27711 8.07001 9.00097 8.07001V8.57001ZM7.15097 8.07001C6.87483 8.07001 6.65097 8.29386 6.65097 8.57001C6.65097 8.84615 6.87483 9.07001 7.15097 9.07001V8.07001ZM8.50098 6.05C8.50098 6.32615 8.72483 6.55 9.00098 6.55C9.27712 6.55 9.50098 6.32615 9.50098 6.05H8.50098ZM9.50098 5.44C9.50098 5.16386 9.27712 4.94 9.00098 4.94C8.72483 4.94 8.50098 5.16386 8.50098 5.44H9.50098ZM16.501 9C16.501 13.1421 13.1431 16.5 9.00098 16.5V17.5C13.6954 17.5 17.501 13.6944 17.501 9H16.501ZM9.00098 16.5C4.85884 16.5 1.50098 13.1421 1.50098 9H0.500977C0.500977 13.6944 4.30656 17.5 9.00098 17.5V16.5ZM1.50098 9C1.50098 4.85786 4.85884 1.5 9.00098 1.5V0.5C4.30656 0.5 0.500977 4.30558 0.500977 9H1.50098ZM9.00098 1.5C13.1431 1.5 16.501 4.85786 16.501 9H17.501C17.501 4.30558 13.6954 0.5 9.00098 0.5V1.5ZM9.00097 8.07001H7.15097V9.07001H9.00097V8.07001ZM6.89099 13.06H11.111V12.06H6.89099V13.06ZM9.50097 11.88V8.57001H8.50097V11.88H9.50097ZM9.50098 6.05V5.44H8.50098V6.05H9.50098Z"
      fill="black"
    />
  </svg>
);

const Alert = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 16 14"
    fill="none"
  >
    <path
      d="M9.17902 1.69051C8.6664 0.769829 7.33089 0.769829 6.81827 1.69051L1.07153 12.0398C0.848942 12.4834 1.1727 13.0143 1.67183 13.0143H14.3255C14.8246 13.0143 15.1551 12.4901 14.9258 12.0398L9.17902 1.69051Z"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 4.00366V8.50901"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 10.5112L8 10.6113"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ChartColumn = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 29 27"
    fill="none"
  >
    <path
      d="M17 14H12V25H17V14Z"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7 8.5H2V25H7V8.5Z"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M27 2H22V25H27V2Z"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const Clock = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 28 28"
    fill="none"
  >
    <path
      d="M14 8.4V14L18.5 18.5M26 14C26 20.6274 20.6274 26 14 26C7.37258 26 2 20.6274 2 14C2 7.37258 7.37258 2 14 2C20.6274 2 26 7.37258 26 14Z"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ChevronRight = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 17 24"
    fill="none"
  >
    <path
      d="M2 22L15 12L2 2"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ChevronLeft = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 17 24"
    fill="none"
  >
    <path
      d="M15 2L2 12L15 22"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const Truck = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 34 22" fill="none">
    <path
      d="M9.35 18.379H19.09V2.43066C19.09 1.67932 18.46 1.06824 17.7 1.06824H2.39C1.62 1.06824 1 1.67932 1 2.43066V18.379H3.78"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M27.43 11.5769H19.08V6.1272H23.25C25.56 6.1272 27.42 11.5769 27.42 11.5769H27.43Z"
      strokeWidth="1"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M30.22 18.379H33V14.2917C33 12.7991 31.75 11.5669 30.22 11.5669H19.09V18.369H24.66"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M27.43 21.1039C28.9654 21.1039 30.21 19.8839 30.21 18.379C30.21 16.8741 28.9654 15.6542 27.43 15.6542C25.8947 15.6542 24.65 16.8741 24.65 18.379C24.65 19.8839 25.8947 21.1039 27.43 21.1039Z"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.57 21.1039C8.10535 21.1039 9.35 19.8839 9.35 18.379C9.35 16.8741 8.10535 15.6542 6.57 15.6542C5.03465 15.6542 3.79 16.8741 3.79 18.379C3.79 19.8839 5.03465 21.1039 6.57 21.1039Z"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const PickUpLocation = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="60"
    height="60"
    viewBox="0 0 60 60"
    fill="none"
  >
    <path
      d="M29.9994 38.6664C29.9994 38.6664 17.6494 27.5175 17.6494 14.3708C17.6494 7.84126 20.8694 1.36047 29.9994 1.36047C39.1294 1.36047 42.3493 7.84126 42.3493 14.3708C42.3493 27.5078 29.9994 38.6664 29.9994 38.6664Z"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M37.2756 14.2244C37.2756 18.0642 34.0148 21.1828 30.0001 21.1828C25.9853 21.1828 22.7246 18.0642 22.7246 14.2244C22.7246 10.3847 25.9853 7.26611 30.0001 7.26611C34.0148 7.26611 37.2756 10.3847 37.2756 14.2244Z"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M42.6875 16.9618H50.0126L59 47.0365H1L9.98735 16.9618H17.3125"
      stroke="#DC196E"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const Locker = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="60"
    height="60"
    viewBox="0 0 60 59"
    fill="none"
  >
    <path
      d="M59 1.19849H1V57.4153H59V1.19849Z"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1 19.9187H59"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1 38.6483H59"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M30.0479 19.9188V1.19849"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const Share = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    viewBox="0 0 18 14"
    fill="none"
  >
    <path
      d="M17 6.9301L11.9287 12.7622C11.4904 13.268 10.7391 12.9123 10.7391 12.209V9.30087C10.7391 9.30087 6.56522 6.9301 1 12.4619C1 12.4619 2.3913 4.55933 10.7391 4.55933V1.79343C10.7391 1.0901 11.4835 0.734483 11.9217 1.23234L17 6.9222V6.9301Z"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const Star = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="13 12 28 30"
  >
    <path
      d="M28.3074 14.5401L30.5221 21.7763C30.7 22.3606 31.2336 22.7471 31.8295 22.7471H39.1316C40.439 22.7471 40.9994 24.4281 39.9587 25.2281L33.9374 29.8754C33.4838 30.226 33.2882 30.8283 33.4571 31.3856L35.7251 38.8195C36.1165 40.1049 34.649 41.1477 33.5817 40.3297L27.8183 35.8801C27.3291 35.5026 26.6442 35.5026 26.1551 35.8801L20.3917 40.3297C19.3333 41.1477 17.8568 40.1049 18.2482 38.8195L20.5162 31.3856C20.6852 30.8283 20.4984 30.226 20.0359 29.8754L14.0413 25.2371C13.0006 24.437 13.561 22.7561 14.8684 22.7561H22.1705C22.7753 22.7561 23.3 22.3606 23.4779 21.7853L25.6926 14.5491C26.0928 13.2457 27.9072 13.2457 28.3074 14.5491V14.5401Z"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const FileArchived = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 30 30"
    fill="none"
  >
    <path
      d="M0.9375 19.2844H8.4375C9.01875 19.2844 9.47813 19.6969 9.62813 20.2594C10.0594 21.8156 11.475 22.95 13.1625 22.95H16.8281C18.5156 22.95 19.9406 21.8062 20.3625 20.2594C20.5125 19.6969 20.9812 19.2844 21.5531 19.2844H29.0531"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.8313 14.6094V0.9375H20.4657L24.1688 4.67812V14.6094"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.3345 7.65936H18.6657"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.3345 12.5531H18.6657"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M29.0625 19.2844V26.625C29.0625 27.975 27.9656 29.0719 26.6156 29.0719H3.38437C2.03437 29.0719 0.9375 27.975 0.9375 26.625V19.2844"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const FileVerified = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 30 30"
    fill="none"
  >
    <path
      d="M0.9375 19.2844H8.4375C9.01875 19.2844 9.47813 19.6969 9.62813 20.2594C10.0594 21.8156 11.475 22.95 13.1625 22.95H16.8281C18.5156 22.95 19.9406 21.8062 20.3625 20.2594C20.5125 19.6969 20.9812 19.2844 21.5531 19.2844H29.0531"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.8313 14.6094V0.9375H20.4657L24.1688 4.67812V14.6094"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M29.0625 19.2844V26.625C29.0625 27.975 27.9656 29.0719 26.6156 29.0719H3.38437C2.03437 29.0719 0.9375 27.975 0.9375 26.625V19.2844"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.1188 9.96564L14.325 14.0906L18.5906 7.38751"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const FileRejected = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 30 30"
    fill="none"
  >
    <path
      d="M0.9375 19.2844H8.4375C9.01875 19.2844 9.47813 19.6969 9.62813 20.2594C10.0594 21.8156 11.475 22.95 13.1625 22.95H16.8281C18.5156 22.95 19.9406 21.8062 20.3625 20.2594C20.5125 19.6969 20.9812 19.2844 21.5531 19.2844H29.0531"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.8313 14.6094V0.9375H20.4657L24.1688 4.67812V14.6094"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M29.0625 19.2844V26.625C29.0625 27.975 27.9656 29.0719 26.6156 29.0719H3.38437C2.03437 29.0719 0.9375 27.975 0.9375 26.625V19.2844"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.6531 7.80939L17.8406 13.9969"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.8406 7.80939L11.6531 13.9969"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const RefreshCW = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 44 44"
    fill="none"
  >
    <path
      d="M2 22C2 10.9565 10.9565 2 22 2C30.1391 2 37.1478 6.86956 40.2609 13.8435"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M40.2609 5.47826V14.1739"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M31.5652 14.1739H40.2609"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.73914 30.1565C6.85218 37.1304 13.8609 42 22 42C33.0435 42 42 33.0435 42 22"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.73914 38.5217V29.8261"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.4348 29.8261H3.73914"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ManualUpload = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 44 44"
    fill="none"
  >
    <path
      d="M42 22C42 10.9543 33.0457 2 22 2C10.9543 2 2 10.9543 2 22C2 33.0457 10.9543 42 22 42C33.0457 42 42 33.0457 42 22Z"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M22 34.7273L22 9.27272"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.0909 20.1818L22 9.27273"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M32.9091 20.1818L22 9.27273"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const Check = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    width="100%"
    height="100%"
    viewBox="0 0 30 30"
  >
    <path d="M 26.980469 5.9902344 A 1.0001 1.0001 0 0 0 26.292969 6.2929688 L 11 21.585938 L 4.7070312 15.292969 A 1.0001 1.0001 0 1 0 3.2929688 16.707031 L 10.292969 23.707031 A 1.0001 1.0001 0 0 0 11.707031 23.707031 L 27.707031 7.7070312 A 1.0001 1.0001 0 0 0 26.980469 5.9902344 z"></path>
  </svg>
);

const Triangle = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path id="Vector" d="M9.6 0L0 16H19.2L9.6 0Z" />
  </svg>
);

const ThreeDots = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="40"
    viewBox="0 0 10 40"
  >
    <path d="M10 5C10 7.76142 7.76142 10 5 10C2.23858 10 0 7.76142 0 5C0 2.23858 2.23858 0 5 0C7.76142 0 10 2.23858 10 5Z" />
    <path d="M10 20C10 22.7614 7.76142 25 5 25C2.23858 25 0 22.7614 0 20C0 17.2386 2.23858 15 5 15C7.76142 15 10 17.2386 10 20Z" />
    <path d="M10 35C10 37.7614 7.76142 40 5 40C2.23858 40 0 37.7614 0 35C0 32.2386 2.23858 30 5 30C7.76142 30 10 32.2386 10 35Z" />
  </svg>
);

const Leaf = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 18 20"
    fill="none"
  >
    <path d="M17.7271 3.67396C17.6413 3.14157 17.1695 2.74426 16.6253 2.74426C16.6226 2.74426 16.6173 2.74426 16.6146 2.74426C13.2313 2.7787 9.96872 3.97062 7.37633 6.10548C7.2959 5.16783 7.02514 4.25403 6.57743 3.41704C5.9662 2.27544 5.04666 1.32191 3.92338 0.65973C3.47032 0.39221 2.90465 0.466374 2.55078 0.839842C0.867201 2.61183 -0.0389297 4.9268 0.0012832 7.35832C0.0388152 9.69977 0.950308 11.9035 2.57491 13.596C2.4221 14.1734 2.30682 14.7615 2.22908 15.3601C2.19691 15.6064 2.37116 15.8315 2.62316 15.866C2.64193 15.8686 2.66338 15.8686 2.68214 15.8686C2.90734 15.8686 3.10304 15.7044 3.13253 15.4766C3.21563 14.8542 3.33895 14.245 3.50517 13.6543C3.52393 13.6146 3.53466 13.5748 3.54002 13.5325C5.18338 7.84038 10.4968 3.70839 16.6307 3.64482C16.6307 3.64482 16.6307 3.64482 16.6333 3.64482C16.7298 3.64482 16.821 3.72164 16.8371 3.81434C17.1749 5.92007 17.1856 8.05493 16.8693 10.1633C16.8639 10.1792 16.8585 10.1951 16.8558 10.211C16.2258 12.8835 14.4672 15.1667 12.0249 16.4725C9.87221 17.6274 7.3656 17.9293 5.01449 17.344C5.80802 16.8275 6.56939 16.2606 7.2959 15.6435C9.21272 14.0145 10.8239 12.0889 12.0839 9.92492C12.2099 9.71037 12.1349 9.4349 11.915 9.31042C11.6979 9.18593 11.4191 9.26009 11.2931 9.47728C9.45399 12.616 6.82407 15.2382 3.69819 17.087C3.68478 17.0923 3.67406 17.1003 3.66066 17.1082C2.65802 17.6989 1.60712 18.2074 0.513328 18.6312C0.280093 18.7213 0.162135 18.9835 0.255965 19.2139C0.325667 19.3914 0.497242 19.5 0.679541 19.5C0.735839 19.5 0.792137 19.4894 0.845754 19.4682C1.92882 19.0497 2.96899 18.5518 3.96627 17.977C5.07615 18.3478 6.22892 18.5332 7.37901 18.5332C9.13229 18.5332 10.8775 18.1068 12.4485 17.2618C15.0918 15.8474 17.006 13.3841 17.711 10.4997C17.7271 10.4626 17.7405 10.4229 17.7459 10.3805C18.0917 8.15558 18.0837 5.89888 17.7271 3.67396ZM4.57751 9.17268C4.57215 8.69062 4.5507 8.24299 4.51317 7.81389C4.43006 6.89744 4.27189 5.93331 4.03062 4.86058C3.977 4.6169 3.73304 4.46592 3.4864 4.5189C3.23976 4.57187 3.08695 4.81291 3.14057 5.05659C3.3738 6.08958 3.52661 7.01663 3.60436 7.89336C3.67942 8.733 3.68747 9.6574 3.62581 10.7937C3.33627 11.3711 3.08427 11.9671 2.87516 12.5816C0.129965 9.34485 0.223795 4.59571 3.21027 1.45434C3.26925 1.39077 3.37112 1.38283 3.45423 1.4305C5.40858 2.58004 6.55867 4.66193 6.48628 6.89744C5.76781 7.59405 5.12977 8.35688 4.57751 9.17268Z" />
  </svg>
);

const DrawerArrows = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M9.26366 0.841797C9.86569 0.905322 10.3709 1.18219 10.831 1.5332C11.3337 1.91674 11.8886 2.47455 12.5351 3.12109L17.707 8.29297L17.7754 8.36914C18.0957 8.76191 18.0731 9.34092 17.707 9.70703C17.3409 10.0731 16.7619 10.0957 16.3691 9.77539L16.293 9.70703L11.1211 4.53516C10.4346 3.84867 9.98911 3.40608 9.61815 3.12305C9.35707 2.92389 9.20022 2.85758 9.09276 2.83691L8.99999 2.82812C8.89236 2.82812 8.72957 2.85778 8.38182 3.12305C8.01087 3.40608 7.56538 3.84867 6.87889 4.53516L1.70702 9.70703C1.31649 10.0976 0.683479 10.0976 0.292954 9.70703C-0.09757 9.31651 -0.09757 8.68349 0.292954 8.29297L5.46483 3.12109C6.11138 2.47455 6.66625 1.91674 7.16893 1.5332C7.69468 1.13213 8.27937 0.828125 8.99999 0.828125L9.26366 0.841797Z" />
    <path d="M9.26366 8.8418C9.86569 8.90532 10.3709 9.18219 10.831 9.5332C11.3337 9.91674 11.8886 10.4745 12.5351 11.1211L17.707 16.293L17.7754 16.3691C18.0957 16.7619 18.0731 17.3409 17.707 17.707C17.3409 18.0731 16.7619 18.0957 16.3691 17.7754L16.293 17.707L11.1211 12.5352C10.4346 11.8487 9.98911 11.4061 9.61815 11.123C9.35707 10.9239 9.20022 10.8576 9.09276 10.8369L8.99999 10.8281C8.89236 10.8281 8.72957 10.8578 8.38182 11.123C8.01087 11.4061 7.56538 11.8487 6.87889 12.5352L1.70702 17.707C1.31649 18.0976 0.683479 18.0976 0.292954 17.707C-0.09757 17.3165 -0.09757 16.6835 0.292954 16.293L5.46483 11.1211C6.11138 10.4745 6.66625 9.91674 7.16893 9.5332C7.69468 9.13213 8.27937 8.82812 8.99999 8.82812L9.26366 8.8418Z" />
  </svg>
);

const Home = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 18 16"
    fill="none"
  >
    <path
      d="M17.2153 6.18393L9.35134 0.919313C9.13742 0.775594 8.85907 0.775594 8.64515 0.919313L0.781839 6.18393C0.490274 6.37886 0.411806 6.77368 0.608387 7.0636C0.730631 7.24531 0.932155 7.34442 1.13701 7.34442C1.2576 7.34442 1.37983 7.31055 1.49052 7.23622L2.0084 6.88932V14.5543C2.0084 14.9053 2.2917 15.1886 2.64274 15.1886H15.3609C15.7119 15.1886 15.9952 14.9053 15.9952 14.5543V6.88932L16.5131 7.23622C16.8047 7.43115 17.1978 7.35268 17.3928 7.06277C17.5877 6.7712 17.5092 6.37804 17.2193 6.1831L17.2153 6.18393ZM10.2673 13.9208H7.72996V10.6937C7.72996 10.4905 7.89515 10.3261 8.09752 10.3261H9.90142C10.1046 10.3261 10.269 10.4913 10.269 10.6937V13.9208H10.2673ZM14.7225 13.9208H11.536V10.6937C11.536 9.79091 10.8025 9.05744 9.89977 9.05744H8.09587C7.1931 9.05744 6.45963 9.79091 6.45963 10.6937V13.9208H3.27311V6.04184L8.997 2.20851L14.7209 6.04184V13.9208H14.7225Z"
      fill="#DC196E"
      strokeWidth="0.2"
    />
  </svg>
);

const Productivity = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 18 18"
    fill="none"
  >
    <path
      d="M9 0.500122C4.30955 0.500122 0.5 4.30967 0.5 9.00012C0.5 13.6906 4.30955 17.5001 9 17.5001C13.6905 17.5001 17.5 13.6906 17.5 9.00012C17.5 4.30967 13.6905 0.500122 9 0.500122ZM14.4091 9.77285H15.9082C15.5218 13.2424 12.57 15.9547 9 15.9547C5.43 15.9547 2.47818 13.2424 2.09182 9.77285H3.59091C4.01591 9.77285 4.36364 9.42512 4.36364 9.00012C4.36364 8.57512 4.01591 8.22739 3.59091 8.22739H2.09182C2.23864 6.89058 2.77182 5.66194 3.57545 4.66512L3.82273 4.91239C3.96955 5.05921 4.16273 5.13649 4.36364 5.13649C4.56455 5.13649 4.75773 5.05921 4.91227 4.91239C5.21364 4.61103 5.21364 4.12421 4.91227 3.82285L4.665 3.56785C5.66182 2.77194 6.89045 2.24649 8.22727 2.09194V3.59103C8.22727 4.01603 8.575 4.36376 9 4.36376C9.425 4.36376 9.77273 4.01603 9.77273 3.59103V2.09194C11.1095 2.23876 12.3382 2.77194 13.335 3.56785L13.0877 3.81512C12.7864 4.11649 12.7864 4.6033 13.0877 4.90467C13.2423 5.05921 13.4355 5.13649 13.6364 5.13649C13.8373 5.13649 14.0305 5.05921 14.185 4.91239L14.4323 4.66512C15.2359 5.66194 15.7614 6.89058 15.9159 8.22739H14.4091C13.9841 8.22739 13.6364 8.57512 13.6364 9.00012C13.6364 9.42512 13.9841 9.77285 14.4091 9.77285Z"
      fill="#DC196E"
      strokeWidth="0.2"
    />
    <path
      d="M10.7688 6.13339L7.67793 9.2243C7.37656 9.52566 7.37656 10.0125 7.67793 10.3138C7.83247 10.4684 8.02565 10.5457 8.22656 10.5457C8.42747 10.5457 8.62065 10.4684 8.7752 10.3216L11.8661 7.23066C12.1675 6.9293 12.1675 6.44248 11.8661 6.14112C11.5647 5.83975 11.0702 5.83203 10.7688 6.13339Z"
      fill="#DC196E"
      strokeWidth="0.2"
    />
  </svg>
);

const Users = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 18 16"
    fill="none"
  >
    <path
      d="M13.2471 0.566467C14.3334 0.645204 15.3055 1.40592 15.6006 2.52252L15.6562 2.78619C15.8524 4.0142 15.1563 5.22342 13.9971 5.6651L13.7412 5.74811C13.6829 5.76366 13.6209 5.77547 13.5566 5.78717H13.7891C15.8249 5.78717 17.5995 7.15876 17.5996 8.98346V11.0108C17.5948 11.1414 17.5727 11.2543 17.5059 11.3506C17.4393 11.4463 17.338 11.513 17.2041 11.5714L17.2002 11.5733C16.2245 11.9477 15.2598 12.189 14.2793 12.2969V13.9122C14.2746 14.0179 14.2575 14.1264 14.2002 14.2247C14.1419 14.3246 14.0483 14.4039 13.9111 14.4649L13.9072 14.4669V14.4659C10.6513 15.7655 7.34874 15.7655 4.09277 14.4659L4.08691 14.4639C3.96999 14.408 3.87652 14.3426 3.81348 14.2501C3.75018 14.157 3.72515 14.0474 3.7207 13.918V12.296C2.74435 12.1871 1.77224 11.9423 0.800781 11.5733L0.797852 11.5723C0.677562 11.523 0.572516 11.4687 0.500977 11.379C0.426667 11.2858 0.400391 11.1691 0.400391 11.0206V8.98346C0.400502 7.1573 2.18217 5.78717 4.21094 5.78717H4.54297C4.45219 5.77798 4.362 5.76649 4.27344 5.75006L4.26562 5.74811C2.86793 5.37275 2.03368 3.92466 2.40625 2.52252L2.47461 2.30475C2.8565 1.23806 3.87388 0.546293 4.97168 0.559631L5.12891 0.569397C5.18235 0.575003 5.23693 0.58293 5.29199 0.591858L5.62305 0.656311L5.62793 0.657288L5.78418 0.704163C6.51144 0.947663 7.05802 1.48699 7.34766 2.14752C7.80654 1.84341 8.34267 1.66246 8.90625 1.64557L9.12305 1.64752C9.34001 1.65768 9.55886 1.69234 9.77539 1.75006L10.041 1.83502C10.2594 1.91636 10.4622 2.02418 10.6504 2.1485C10.9593 1.43867 11.572 0.872616 12.3721 0.657288V0.658264C12.3807 0.655946 12.3874 0.654479 12.3887 0.654358H12.3896C12.6017 0.597183 12.8138 0.562322 13.0283 0.559631L13.2471 0.566467ZM8.13574 8.79401C6.18366 8.79422 4.69336 10.0764 4.69336 11.5001V13.6485C7.57279 14.7384 10.4203 14.737 13.2998 13.6485V11.5001C13.2998 10.0762 11.816 8.79422 9.86426 8.79401H8.13574ZM4.00195 6.77545C3.49773 6.82225 2.91248 6.99312 2.42188 7.31061C1.86326 7.67222 1.43254 8.22021 1.37305 8.99127V10.7471C2.1631 11.0298 2.94854 11.2177 3.72656 11.3126C3.84422 9.32319 5.82181 7.83409 8.09766 7.81744C7.9816 7.66842 7.8399 7.52938 7.67285 7.40436H7.67188C7.52763 7.31238 7.37589 7.2154 7.21484 7.12897V7.12799C6.77608 6.89827 6.25319 6.76276 5.68262 6.76276H4.21289L4.00195 6.77545ZM12.3242 6.76276C11.7742 6.76276 11.2467 6.89388 10.8223 7.10358L10.8193 7.10455C10.6054 7.20288 10.4712 7.29504 10.2627 7.42291L10.124 7.54401C10.0361 7.62864 9.95674 7.71989 9.88672 7.81744C12.1691 7.82737 14.1545 9.31868 14.2725 11.3126C15.0585 11.2184 15.8316 11.0286 16.627 10.7403V8.98346C16.6268 7.82639 15.4129 6.76276 13.7891 6.76276H12.3242ZM8.72168 2.63678C8.2386 2.70101 7.79997 2.95916 7.4375 3.35748C7.12743 3.72677 6.95813 4.22764 6.95215 4.72858C6.9798 5.61712 7.57225 6.41986 8.47168 6.66119H8.4707C9.56421 6.95231 10.6805 6.3038 10.9707 5.20709L11.0156 5.00104C11.1858 3.97324 10.5617 2.97198 9.5293 2.69147V2.69244C9.33085 2.63956 9.12631 2.61543 8.93262 2.62115H8.93066L8.72168 2.63678ZM11.874 5.57037C11.8473 5.65643 11.8169 5.7398 11.7832 5.82135C11.9609 5.8004 12.1409 5.78717 12.3242 5.78717H12.4844C12.2651 5.746 12.0537 5.67666 11.874 5.57037ZM6.1123 5.55963C5.85484 5.67848 5.55189 5.75581 5.2334 5.78717H5.68262C5.86199 5.78717 6.0361 5.80097 6.20801 5.82135C6.17234 5.73591 6.1402 5.64853 6.1123 5.55963ZM4.87402 1.54205C4.28327 1.57712 3.5979 1.97922 3.34473 2.78033C3.11052 3.67041 3.63232 4.56845 4.51855 4.80573H4.51953L4.72363 4.84772C5.18663 4.91275 5.64158 4.77098 5.99023 4.48444C6.0025 4.29511 6.02641 4.09694 6.08301 3.89264L6.09473 3.86627L6.0957 3.86432C6.1948 3.50336 6.36004 3.18172 6.57031 2.89655C6.45145 2.28749 6.01442 1.76988 5.375 1.59967V1.59869C5.21893 1.56953 5.04866 1.5375 4.87402 1.54205ZM12.9629 1.54205H12.9609C12.8509 1.54804 12.7406 1.56845 12.625 1.59869L12.626 1.59967C11.9937 1.76922 11.5498 2.28597 11.4346 2.88971C11.7703 3.3513 11.9723 3.90354 12.0088 4.48444C12.4098 4.80927 12.9552 4.94978 13.4873 4.80573H13.4883L13.6504 4.75397C14.3856 4.47582 14.8219 3.72207 14.6963 2.94342L14.6611 2.77643C14.4537 1.99069 13.7328 1.49149 12.9629 1.54205ZM6.11523 3.84088C6.11423 3.84188 6.11278 3.84317 6.11133 3.84479C6.11282 3.84333 6.1144 3.8426 6.11523 3.84186L6.12109 3.836L6.11523 3.84088Z"
      fill="#DC196E"
      stroke="#DC196E"
      strokeWidth="0.2"
    />
  </svg>
);

const FolderOpen = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 22 18"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      strokeWidth="0.2"
      d="M0.426359 15.4517C0.414145 15.8769 0.538428 16.301 0.790319 16.6577C1.16324 17.1859 1.77005 17.5001 2.4167 17.5001H17.1502C17.9929 17.5001 18.7446 16.9695 19.0268 16.1751C19.0268 16.175 19.0269 16.1749 19.0269 16.1748C19.5795 14.6168 20.7372 11.354 21.4597 9.31713L21.4595 9.31757C21.6762 8.70814 21.5832 8.03141 21.2098 7.50264C21.2097 7.50254 21.2096 7.50245 21.2095 7.50235C20.8362 6.97435 20.2299 6.66026 19.5833 6.66026H18.7515V4.87106C18.7515 4.34285 18.5416 3.83659 18.1682 3.46322C17.7948 3.08986 17.2885 2.87988 16.7603 2.87988H11.8771C11.6897 2.87988 11.511 2.80058 11.3853 2.66173C11.3853 2.66171 11.3853 2.66169 11.3853 2.66167C10.9973 2.23328 10.4093 1.58357 10.0214 1.15518C9.64414 0.738117 9.1075 0.500122 8.5453 0.500122H2.4167C1.31706 0.500122 0.425537 1.39174 0.425537 2.49138V15.4186C0.425537 15.4297 0.425805 15.4408 0.426359 15.4517ZM20.2086 8.87287C20.2085 8.873 20.2085 8.87315 20.2084 8.87331C19.486 10.9101 18.3283 14.1726 17.7757 15.7307C17.6817 15.9955 17.4311 16.1724 17.1502 16.1724H2.41672C2.20134 16.1724 1.99914 16.0679 1.87492 15.892C1.8749 15.8919 1.87488 15.8919 1.87486 15.8919C1.7504 15.7156 1.71934 15.4901 1.79135 15.287C2.51409 13.2502 3.6718 9.98793 4.22432 8.42973C4.31844 8.1649 4.56892 7.98792 4.84985 7.98792H19.5833C19.7989 7.98792 20.0009 8.09271 20.1254 8.26868C20.2497 8.44472 20.2807 8.66999 20.2086 8.87287ZM17.4239 6.66026V4.87106C17.4239 4.69506 17.3538 4.52641 17.2294 4.40201C17.105 4.2776 16.9363 4.20754 16.7603 4.20754H11.8772C11.3145 4.20754 10.7784 3.96955 10.4012 3.55285C10.0132 3.12443 9.42511 2.47467 9.03721 2.04626C9.03716 2.04618 9.0371 2.04613 9.03704 2.04607C8.91133 1.90709 8.73258 1.82778 8.54532 1.82778H2.41672C2.05027 1.82778 1.75321 2.12493 1.75321 2.49138V11.4244C2.22636 10.0909 2.68314 8.80346 2.97314 7.98565C2.97318 7.98551 2.97324 7.98538 2.97328 7.98523C3.25558 7.19081 4.00716 6.66026 4.84985 6.66026H17.4239Z"
      fill="#DC196E"
    />
  </svg>
);

const Payments = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 18 14"
    fill="none"
  >
    <path
      d="M15.4111 0.772461L15.627 0.783203C16.128 0.833362 16.5989 1.05491 16.958 1.41406L17.1035 1.57422C17.4227 1.96357 17.599 2.45312 17.5996 2.96094V11.0381L17.5889 11.2549C17.5459 11.6844 17.3772 12.092 17.1035 12.4258L16.958 12.5859C16.5477 12.9963 15.9914 13.2269 15.4111 13.2275H2.58887C2.08106 13.227 1.59149 13.0506 1.20215 12.7314L1.04199 12.5859C0.631533 12.1755 0.400939 11.6186 0.400391 11.0381V2.96094L0.411133 2.74512C0.461292 2.2441 0.682836 1.77322 1.04199 1.41406L1.20215 1.26855C1.59149 0.949403 2.08105 0.773047 2.58887 0.772461H15.4111ZM1.58789 11.0381L1.59375 11.1367C1.61677 11.3659 1.71753 11.5818 1.88184 11.7461C2.0695 11.9337 2.32446 12.0386 2.58984 12.0391H15.4102L15.5098 12.0342C15.7386 12.011 15.9541 11.9102 16.1182 11.7461C16.3058 11.5584 16.4116 11.3035 16.4121 11.0381V9.96582H1.58789V11.0381ZM1.58789 8.77832H16.4121V7.79199H1.58789V8.77832ZM2.49023 1.96582C2.26137 1.98902 2.04592 2.08982 1.88184 2.25391C1.69417 2.44157 1.58837 2.69652 1.58789 2.96191V6.60352H16.4121V2.96191L16.4062 2.8623C16.3831 2.63344 16.2823 2.41799 16.1182 2.25391C15.9541 2.08982 15.7386 1.98902 15.5098 1.96582L15.4102 1.95996H2.58984L2.49023 1.96582Z"
      fill="#DC196E"
      stroke="#DC196E"
      strokeWidth="0.2"
    />
  </svg>
);

const DoubleArrow = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 24 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.61621 17L10.6667 9L1.61621 1"
      stroke="black"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.3335 17L22.384 9L13.3335 1"
      stroke="black"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const Logout = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.49988 15.9996H4.99975V13.9997H2.49988C2.36728 13.9997 2.2401 13.947 2.14634 13.8532C2.05258 13.7595 1.9999 13.6323 1.9999 13.4997V2.50024C1.9999 2.36764 2.05258 2.24047 2.14634 2.14671C2.2401 2.05294 2.36728 2.00027 2.49988 2.00027H4.99975V0.000366211H2.49988C1.83687 0.000366211 1.20101 0.263745 0.732197 0.732563C0.263379 1.20138 0 1.83723 0 2.50024V13.4997C0 13.828 0.064661 14.1531 0.190292 14.4564C0.315922 14.7597 0.500062 15.0352 0.732197 15.2674C0.964332 15.4995 1.23992 15.6837 1.54322 15.8093C1.84651 15.9349 2.17159 15.9996 2.49988 15.9996Z"
      fill="black"
    />
    <path
      d="M11.9994 3.58521L10.5844 5.00014L12.5843 7.00004H3.99976V8.99994H12.5843L10.5844 10.9998L11.9994 12.4148L15.7067 8.70745C15.7997 8.61459 15.8734 8.5043 15.9237 8.38291C15.9741 8.26152 16 8.1314 16 7.99999C16 7.86858 15.9741 7.73846 15.9237 7.61707C15.8734 7.49567 15.7997 7.38539 15.7067 7.29252L11.9994 3.58521Z"
      fill="black"
    />
  </svg>
);

const FilterArrowUpDown = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 16 13"
    fill="none"
  >
    <path
      d="M4 1C4 1 4 1.02543 4 2.98001C4 4.93459 4 12 4 12"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7 4L4 1L1 4"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 12C12 12 12 11.9746 12 10.02C12 8.06541 12 1 12 1"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9 9L12 12L15 9"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const DrawerArrow = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
  >
    <path d="M9.2636 0.841797C9.86563 0.905322 10.3709 1.18219 10.831 1.5332C11.3337 1.91674 11.8885 2.47455 12.5351 3.12109L17.707 8.29297L17.7753 8.36914C18.0957 8.76191 18.0731 9.34092 17.707 9.70703C17.3408 10.0731 16.7618 10.0957 16.3691 9.77539L16.2929 9.70703L11.121 4.53516C10.4345 3.84867 9.98905 3.40608 9.61809 3.12305C9.35701 2.92389 9.20016 2.85758 9.0927 2.83691L8.99992 2.82812C8.8923 2.82812 8.72951 2.85778 8.38176 3.12305C8.0108 3.40608 7.56532 3.84867 6.87883 4.53516L1.70696 9.70703C1.31643 10.0976 0.683418 10.0976 0.292893 9.70703C-0.0976311 9.31651 -0.0976311 8.68349 0.292893 8.29297L5.46477 3.12109C6.11132 2.47455 6.66619 1.91674 7.16887 1.5332C7.69462 1.13213 8.27931 0.828125 8.99992 0.828125L9.2636 0.841797Z" />
    <path d="M9.2636 8.8418C9.86563 8.90532 10.3709 9.18219 10.831 9.5332C11.3337 9.91674 11.8885 10.4745 12.5351 11.1211L17.707 16.293L17.7753 16.3691C18.0957 16.7619 18.0731 17.3409 17.707 17.707C17.3408 18.0731 16.7618 18.0957 16.3691 17.7754L16.2929 17.707L11.121 12.5352C10.4345 11.8487 9.98905 11.4061 9.61809 11.123C9.35701 10.9239 9.20016 10.8576 9.0927 10.8369L8.99992 10.8281C8.8923 10.8281 8.72951 10.8578 8.38176 11.123C8.0108 11.4061 7.56532 11.8487 6.87883 12.5352L1.70696 17.707C1.31643 18.0976 0.683418 18.0976 0.292893 17.707C-0.0976311 17.3165 -0.0976311 16.6835 0.292893 16.293L5.46477 11.1211C6.11132 10.4745 6.66619 9.91674 7.16887 9.5332C7.69462 9.13213 8.27931 8.82812 8.99992 8.82812L9.2636 8.8418Z" />
  </svg>
);

const UserCircle = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="19"
    height="19"
    viewBox="0 0 19 19"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.5 2.0625C5.39238 2.0625 2.0625 5.39238 2.0625 9.5C2.0625 11.3941 2.77052 13.1228 3.93633 14.4359C4.74456 13.11 6.06588 12.1048 7.63629 11.6543C6.69422 11.0432 6.07102 9.98215 6.07102 8.77557C6.07102 6.8818 7.60623 5.34659 9.5 5.34659C11.3938 5.34659 12.929 6.8818 12.929 8.77557C12.929 9.98218 12.3058 11.0432 11.3636 11.6544C12.9341 12.1048 14.2554 13.1101 15.0636 14.436C16.2294 13.1229 16.9375 11.3941 16.9375 9.5C16.9375 5.39238 13.6076 2.0625 9.5 2.0625ZM14.2778 15.2001C13.3995 13.5839 11.5974 12.4565 9.4999 12.4565C7.40247 12.4565 5.60037 13.5838 4.72204 15.2C6.0144 16.2845 7.68094 16.9375 9.5 16.9375C11.319 16.9375 12.9855 16.2845 14.2778 15.2001ZM1 9.5C1 4.80558 4.80558 1 9.5 1C14.1944 1 18 4.80558 18 9.5C18 14.1944 14.1944 18 9.5 18C4.80558 18 1 14.1944 1 9.5ZM9.5 6.40909C8.19303 6.40909 7.13352 7.4686 7.13352 8.77557C7.13352 10.0825 8.19303 11.142 9.5 11.142C10.807 11.142 11.8665 10.0825 11.8665 8.77557C11.8665 7.4686 10.807 6.40909 9.5 6.40909Z"
      fill="#DC196E"
      stroke="#DC196E"
      strokeWidth="0.4"
    />
  </svg>
);

const Documents = (
  <svg
    width="100%"
    height="100%"
    fill="none"
    className="fill-primary-magenta"
    version="1.1"
    viewBox="0 0 100 100"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="m31.117 3.9297 1.7227-0.73047h44.281c4.8867 0 8.8789 4 8.8789 8.8789v75.84c0 2.3555-1.0234 4.7734-2.6133 6.2695l0.003906 0.003906c-1.6094 1.6094-3.8281 2.6055-6.2734 2.6055l-54.238 0.003906c-4.8867 0-8.8789-4-8.8789-8.8789v-65.883l0.73047-1.7227zm1.6172 40.973h34.527c3.1602 0 3.1602-4.8008 0-4.8008h-34.527c-3.1602 0-3.1602 4.8008 0 4.8008zm0 32.641h34.527c3.1602 0 3.1602-4.8008 0-4.8008h-34.527c-3.1602 0-3.1602 4.8008 0 4.8008zm0-16.32h34.527c3.1602 0 3.1602-4.8008 0-4.8008h-34.527c-3.1602 0-3.1602 4.8008 0 4.8008zm-13.934-36.785v63.484c0 2.2539 1.8477 4.0781 4.0781 4.0781h54.242c1.1172 0 2.1406-0.46094 2.8789-1.1992l0.003906 0.003907c0.73828-0.73828 1.1953-1.7617 1.1953-2.8828v-75.844c0-2.2539-1.8477-4.0781-4.0781-4.0781h-41.883v8.5742c0 4.3164-3.5469 7.8633-7.8633 7.8633l-8.5742 0.003906zm11.641-7.8633v-5.1836l-8.2461 8.2461h5.1836c1.6914 0.003906 3.0625-1.3672 3.0625-3.0625z"
      fillRule="evenodd"
    />
  </svg>
);

const Money = (
  <svg
    width="100%"
    height="100%"
    fill="none"
    className="fill-primary-magenta"
    version="1.1"
    viewBox="0 0 100 100"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fillRule="evenodd">
      <path d="m91.668 12.5c0-7.4023-12.234-12.5-27.086-12.5-14.848 0-27.082 5.0977-27.082 12.5s12.234 12.5 27.082 12.5c14.852 0 27.086-5.0977 27.086-12.5zm-50 0c0-4.1055 10.148-8.332 22.914-8.332s22.918 4.2266 22.918 8.332-10.152 8.332-22.918 8.332-22.914-4.2266-22.914-8.332z" />
      <path d="m37.5 25c0 7.4023 12.234 12.5 27.082 12.5 14.852 0 27.086-5.0977 27.086-12.5v-12.5h-4.168v12.5c0 4.1055-10.152 8.332-22.918 8.332s-22.914-4.2266-22.914-8.332v-12.5h-4.168z" />
      <path d="m37.5 37.539v-0.039062-12.5h4.168v12.5c0 0.11719 0.007812 0.23047 0.023437 0.34766-1.3477-0.15234-2.75-0.25781-4.1914-0.30859zm20.914 12.156c1.9844 0.19922 4.0508 0.30469 6.168 0.30469 14.852 0 27.086-5.0977 27.086-12.5v-12.5h-4.168v12.5c0 4.1055-10.152 8.332-22.918 8.332-2.1797 0-4.2812-0.12109-6.2734-0.34766 0.015625 0.11719 0.023437 0.23438 0.023437 0.34766 0 0.34766 0.03125 1.7578 0.082031 3.8633z" />
      <path d="m58.734 62.227c1.8867 0.17969 3.8438 0.27344 5.8477 0.27344 14.852 0 27.086-5.0977 27.086-12.5v-12.5h-4.168v12.5c0 4.1055-10.152 8.332-22.918 8.332-2.0625 0-4.0625-0.10938-5.957-0.3125 0.035156 1.3555 0.070312 2.7656 0.10938 4.207zm-17.066-24.383v-0.34375h-4.168v0.039062c1.4336 0.050782 2.8242 0.15625 4.168 0.30469z" />
      <path d="m62.5 50c0-7.4023-12.234-12.5-27.082-12.5-14.852 0-27.086 5.0977-27.086 12.5s12.234 12.5 27.086 12.5c14.848 0 27.082-5.0977 27.082-12.5zm-50 0c0-4.1055 10.152-8.332 22.918-8.332s22.914 4.2266 22.914 8.332-10.148 8.332-22.914 8.332-22.918-4.2266-22.918-8.332z" />
      <path d="m8.332 62.5c0 7.4023 12.234 12.5 27.086 12.5 14.848 0 27.082-5.0977 27.082-12.5v-12.5h-4.168v12.5c0 4.1055-10.148 8.332-22.914 8.332s-22.918-4.2266-22.918-8.332v-12.5h-4.168z" />
      <path d="m8.332 75c0 7.4023 12.234 12.5 27.086 12.5 14.848 0 27.082-5.0977 27.082-12.5v-12.5h-4.168v12.5c0 4.1055-10.148 8.332-22.914 8.332s-22.918-4.2266-22.918-8.332v-12.5h-4.168z" />
      <path d="m8.332 87.5c0 7.4023 12.234 12.5 27.086 12.5 14.848 0 27.082-5.0977 27.082-12.5v-12.5h-4.168v12.5c0 4.1055-10.148 8.332-22.914 8.332s-22.918-4.2266-22.918-8.332v-12.5h-4.168z" />
      <path d="m59.066 74.758c1.7852 0.16016 3.6289 0.24219 5.5156 0.24219 14.852 0 27.086-5.0977 27.086-12.5v-12.5h-4.168v12.5c0 4.1055-10.152 8.332-22.918 8.332-1.9453 0-3.8281-0.097656-5.625-0.27734 0.035157 1.4375 0.074219 2.8477 0.10938 4.2031z" />
      <path d="m59.406 87.289c1.6758 0.13672 3.4102 0.21094 5.1758 0.21094 14.852 0 27.086-5.0977 27.086-12.5v-12.5h-4.168v12.5c0 4.1055-10.152 8.332-22.918 8.332-1.8242 0-3.5938-0.085937-5.2891-0.24609 0.058593 2.1523 0.097656 3.668 0.11328 4.2031z" />
    </g>
  </svg>
);

const KPI = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 367.39 367.39">
    <defs>
      <style>
        {`
  .cls-1 {
    fill: none;
  }
  .cls-2 {
    mask: url(#mask);
  }
  .cls-3 {
    filter: url(#luminosity-noclip);
  }
  .cls-4 {
    mask: url(#mask-1);
  }
  .cls-5 {
    fill: #eb74b1;
  }
  .cls-6, .cls-7, .cls-8, .cls-9 {
    fill: #fff;
  }
  .cls-10 {
    fill: url(#linear-gradient);
    mix-blend-mode: multiply;
  }
  .cls-7 {
    stroke: url(#Sfumatura_senza_nome_49-2);
  }
  .cls-7, .cls-8, .cls-9 {
    stroke-miterlimit: 10;
    stroke-width: 10px;
  }
  .cls-8 {
    stroke: url(#Sfumatura_senza_nome_49-3);
  }
  .cls-9 {
    stroke: url(#Sfumatura_senza_nome_49);
  }
`}
      </style>
      <linearGradient
        id="Sfumatura_senza_nome_49"
        data-name="Sfumatura senza nome 49"
        x1="39.57"
        y1="255.78"
        x2="132.4"
        y2="255.78"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#eb74b1" />
        <stop offset="1" stopColor="#dd177d" />
      </linearGradient>
      <linearGradient
        id="Sfumatura_senza_nome_49-2"
        data-name="Sfumatura senza nome 49"
        x1="137.28"
        y1="215.3"
        x2="230.11"
        y2="215.3"
      />
      <linearGradient
        id="Sfumatura_senza_nome_49-3"
        data-name="Sfumatura senza nome 49"
        x1="234.99"
        y1="187.41"
        x2="327.82"
        y2="187.41"
      />
      <filter
        id="luminosity-noclip"
        x="44.57"
        y="44.08"
        width="133.23"
        height="133.23"
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodColor="#fff" result="bg" />
        <feBlend in="SourceGraphic" in2="bg" />
      </filter>
      <filter
        id="luminosity-noclip-2"
        x="44.57"
        y="-10397.49"
        width="133.23"
        height="32766"
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodColor="#fff" result="bg" />
        <feBlend in="SourceGraphic" in2="bg" />
      </filter>
      <mask
        id="mask-1"
        x="44.57"
        y="-10397.49"
        width="133.23"
        height="32766"
        maskUnits="userSpaceOnUse"
      />
      <linearGradient
        id="linear-gradient"
        x1="44.57"
        y1="110.69"
        x2="177.8"
        y2="110.69"
        gradientTransform="translate(110.84 -46.2) rotate(45)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#e6e6e6" />
        <stop offset="1" stopColor="#999" />
      </linearGradient>
      <mask
        id="mask"
        x="44.57"
        y="44.08"
        width="133.23"
        height="133.23"
        maskUnits="userSpaceOnUse"
      >
        <g className="cls-3">
          <g className="cls-4">
            <circle
              className="cls-10"
              cx="111.18"
              cy="110.69"
              r="66.61"
              transform="translate(-45.71 111.04) rotate(-45)"
            />
          </g>
        </g>
      </mask>
    </defs>
    <g id="Livello_1-2" data-name="Livello 1">
      <g>
        <rect className="cls-1" x="0" width="367.39" height="367.39" />
        <g>
          <rect
            className="cls-9"
            x="44.57"
            y="208.45"
            width="82.83"
            height="94.66"
            rx="30.18"
            ry="30.18"
          />
          <rect
            className="cls-7"
            x="142.28"
            y="127.49"
            width="82.83"
            height="175.62"
            rx="30.18"
            ry="30.18"
          />
          <rect
            className="cls-8"
            x="239.99"
            y="71.7"
            width="82.83"
            height="231.41"
            rx="30.18"
            ry="30.18"
          />
        </g>
        <g className="cls-2">
          <circle
            className="cls-5"
            cx="111.18"
            cy="110.69"
            r="66.61"
            transform="translate(-45.71 111.04) rotate(-45)"
          />
        </g>
        <path
          className="cls-6"
          d="M113.99,147.72c3.31,0,6.21-2.23,7.06-5.41l12.99-48.47c.59-2.21.14-4.51-1.25-6.32-1.38-1.79-3.53-2.86-5.77-2.86-.64,0-1.28.08-1.91.25l-48.48,12.99c-2.54.68-4.47,2.61-5.16,5.16-.68,2.55.03,5.18,1.89,7.05l.39.39,20.62,9.64c1.92.9,3.47,2.45,4.37,4.37l9.71,20.69.39.39c1.38,1.38,3.21,2.14,5.14,2.14"
        />
      </g>
    </g>
  </svg>
);

const Heart = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    data-name="Livello 2"
    viewBox="0 0 227.13 202.7"
  >
    <path
      d="M217.13 67.49v.12c0 6.55-.74 13.1-2.5 19.41-1.18 4.24-2.75 8.36-4.83 12.4-7.32 15.14-23.24 31.85-35.8 43.01l-15.45 13.73-40.62 34.92a6.72 6.72 0 0 1-8.75 0l-40.62-34.92-15.45-13.73c-8.13-7.23-15.57-14.79-22.54-23.15C17.55 103.66 8.7 85.94 10.14 65.21c2.08-29.95 23.08-54.57 54.04-55.2 22.31-.46 38.91 13.1 49.37 32.22 10.45-19.12 27.07-32.7 49.36-32.22 16.71.15 31.83 8.08 41.84 21.32 6.83 9.04 10.44 19.48 11.98 30.42.27 1.9.4 3.82.4 5.74Z"
      data-name="Livello 1"
      style={{ strokeMiterlimit: 10, strokeWidth: "20px" }}
    />
  </svg>
);

const Message = (
  <svg
    id="Livello_2"
    data-name="Livello 2"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 223.06 219.51"
  >
    <defs>
      <style>
        {`
           .message-cls-1 {
          fill: url(#Sfumatura_senza_nome_49);
        }

          .message-cls-2 {
          fill: #eb74b1;
        }

          .message-cls-3 {
          fill: #fff;
        }

          .message-cls-4 {
          opacity: .8;
        }
          `}
      </style>
      <linearGradient
        id="Sfumatura_senza_nome_49"
        x1="0"
        y1="109.76"
        x2="223.06"
        y2="109.76"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#eb74b1" />
        <stop offset="1" stopColor="#dd177d" />
      </linearGradient>
    </defs>
    <g id="Livello_1-2">
      <g>
        <path
          className="message-cls-1"
          d="M192.14,58.89l20.7,17.81c6.48,5.59,10.22,13.73,10.22,22.3v91.11c0,16.24-13.17,29.41-29.41,29.41H29.41c-16.25,0-29.41-13.17-29.41-29.41v-95.37c0-9.03,4.16-17.57,11.27-23.15l21.36-16.73,48.61-38.09,13.4-10.5c11.05-8.66,26.68-8.3,37.32.85l11.21,9.65,48.96,42.13Z"
        />
        <g className="message-cls-4">
          <path
            className="message-cls-2"
            d="M111.53,10.84c-51.27,0-92.84,41.57-92.84,92.84,0,1.96.08,3.91.2,5.84l94.42,49.31,90.48-44.87c.37-3.38.58-6.8.58-10.28,0-51.27-41.57-92.84-92.84-92.84Z"
          />
        </g>
        <path
          className="message-cls-3"
          d="M138.12,108.92c-1.05-.87-2.6-.72-3.47.33-5.32,6.44-13.15,10.14-21.5,10.14-11.77,0-21.84-7.34-25.92-17.67h24.73c1.36,0,2.46-1.1,2.46-2.46s-1.1-2.46-2.46-2.46h-26.16c-.33-1.7-.5-3.46-.5-5.26,0-.78.04-1.55.1-2.32h26.56c1.36,0,2.46-1.1,2.46-2.46s-1.1-2.46-2.46-2.46h-25.7c3.2-11.86,14.04-20.61,26.89-20.61,6.68,0,13.15,2.4,18.2,6.77,1.03.89,2.58.78,3.47-.25.89-1.03.78-2.58-.25-3.47-5.95-5.13-13.55-7.96-21.42-7.96-15.58,0-28.66,10.94-31.96,25.54h-10.09c-1.36,0-2.46,1.1-2.46,2.46s1.1,2.46,2.46,2.46h9.36c-.05.77-.09,1.54-.09,2.32,0,1.79.15,3.54.43,5.26h-9.7c-1.36,0-2.46,1.1-2.46,2.46s1.1,2.46,2.46,2.46h10.9c4.29,13.1,16.63,22.6,31.15,22.6,9.82,0,19.04-4.35,25.29-11.93.87-1.05.72-2.6-.33-3.47Z"
        />
        <path
          className="message-cls-3"
          d="M61.46,190.36c3.31,0,6.21-2.23,7.06-5.41l12.99-48.47c.59-2.21.14-4.51-1.25-6.32-1.38-1.79-3.53-2.86-5.77-2.86-.64,0-1.28.08-1.91.25l-48.48,12.99c-2.54.68-4.47,2.61-5.16,5.16-.68,2.55.03,5.18,1.89,7.05l.39.39,20.62,9.64c1.92.9,3.47,2.45,4.37,4.37l9.71,20.69.39.39c1.38,1.38,3.21,2.14,5.14,2.14"
        />
      </g>
    </g>
  </svg>
);

const Bin = (
  <svg
    id="Livello_2"
    data-name="Livello 2"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 25.2 28"
  >
    <defs>
      <style>
        {`
          .bin-cls-1 {
          fill: url(#Sfumatura_senza_nome_49);
        }

          .bin-cls-2 {
          fill: url(#Sfumatura_senza_nome_49-3);
        }

          .bin-cls-3 {
          fill: url(#Sfumatura_senza_nome_49-2);
        }
          `}
      </style>
      <linearGradient
        id="Sfumatura_senza_nome_49"
        data-name="Sfumatura senza nome 49"
        x1="0"
        y1="14"
        x2="25.2"
        y2="14"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#fc6bb2" />
        <stop offset="1" stopColor="#f1007e" />
      </linearGradient>
      <linearGradient
        id="Sfumatura_senza_nome_49-2"
        data-name="Sfumatura senza nome 49"
        x1="8.95"
        y1="17.36"
        x2="11.11"
        y2="17.36"
      >
        <stop offset="0" stopColor="#fc6bb2" />
        <stop offset="1" stopColor="#f1007e" />
      </linearGradient>
      <linearGradient
        id="Sfumatura_senza_nome_49-3"
        data-name="Sfumatura senza nome 49"
        x1="14.1"
        y1="17.36"
        x2="16.26"
        y2="17.36"
      >
        <stop offset="0" stopColor="#fc6bb2" />
        <stop offset="1" stopColor="#f1007e" />
      </linearGradient>
    </defs>
    <g id="Livello_1-2" data-name="Livello 1">
      <g>
        <path
          className="bin-cls-1"
          d="M24.46,4.66c-.08-.01-.15-.02-.23-.01h-5.32v-2.19c0-1.35-1.1-2.45-2.45-2.46h-7.72c-1.36,0-2.45,1.1-2.46,2.46v2.19H1.1c-.73,0-1.1.29-1.1,1.04v3.14h1.76l1.11,14.63c.08,1.21.6,2.35,1.44,3.21.83.85,1.97,1.32,3.16,1.32h10.25c1.19,0,2.33-.47,3.16-1.32.85-.86,1.36-2,1.44-3.21l1.11-14.63h1.76v-3.37c-.03-.41-.34-.74-.74-.8ZM9.03,2.75h7.15v1.9h-7.15v-1.9ZM21.28,8.89l-1.1,14.42c-.04.69-.33,1.35-.82,1.85-.43.44-1.02.69-1.64.68H7.46c-.62,0-1.21-.24-1.64-.68-.48-.5-.77-1.15-.81-1.85l-1.08-14.44h17.35Z"
        />
        <path
          className="bin-cls-3"
          d="M10.08,22.48c.6-.03,1.06-.53,1.03-1.13v-7.99s0-.07,0-.1c-.03-.6-.53-1.06-1.13-1.03s-1.06.53-1.03,1.13v7.99s0,.07,0,.1c.03.6.53,1.06,1.13,1.03Z"
        />
        <path
          className="bin-cls-2"
          d="M15.23,22.48c.6-.03,1.06-.53,1.03-1.13v-7.99s0-.07,0-.1c-.03-.6-.53-1.06-1.13-1.03s-1.06.53-1.03,1.13v7.99s0,.07,0,.1c.03.6.53,1.06,1.13,1.03Z"
        />
      </g>
    </g>
  </svg>
);

const Mail = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 27.76 20.23">
    <defs>
      <style>
        {`
           .mail-cls-1 {
          fill: url(#Sfumatura_senza_nome_49);
        }
          `}
      </style>
      <linearGradient
        id="Sfumatura_senza_nome_49"
        data-name="Sfumatura senza nome 49"
        x1="0"
        y1="10.11"
        x2="27.76"
        y2="10.11"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#fc6bb2" />
        <stop offset="1" stopColor="#f1007e" />
      </linearGradient>
    </defs>
    <g id="Livello_1-2" data-name="Livello 1">
      <path
        className="mail-cls-1"
        d="M25.21,0H2.55C1.14,0,0,1.14,0,2.55v15.12c0,1.41,1.14,2.55,2.55,2.55h22.65c1.41,0,2.55-1.14,2.55-2.55V2.55c0-1.41-1.14-2.55-2.55-2.55ZM3.17,2.62c.11.01.22.02.35.02,2.73,0,5.36,0,7.91,0,.74,0,4.57,0,11.48,0,.42,0,.93,0,1.54,0,.05,0,.08,0,.11,0,.05,0,.05,0,.02.04-.85.71-1.85,1.54-3,2.47-.2.17-.4.33-.59.49-.83.68-1.25,1.04-1.29,1.06-1.47,1.2-2.31,1.89-2.53,2.07-.94.77-1.89,1.54-2.83,2.32-.1.08-.23.19-.39.31-.02.02-.06.02-.08,0-.08-.05-.17-.11-.24-.17-.07-.06-.71-.57-1.91-1.54-.47-.38-1.16-.94-2.06-1.68-.24-.2-.54-.43-.77-.62-.21-.17-.76-.62-1.65-1.34-1.29-1.05-2.47-2.03-4.05-3.33-.08-.07-.08-.1,0-.09ZM3.95,15.02c-.06.05-.46.4-1.2,1.05-.04.04-.09.07-.13.1,0,0,0,0-.01,0-.01,0-.02,0-.02-.02V5.56s0,0,0,0c0,0,.02-.01.03,0,.03.02.06.04.09.06.01,0,.15.12.41.34.46.37,1.02.85,1.71,1.42.18.15.4.31.55.44.5.43,1,.85,1.51,1.26.43.35.86.74,1.27,1.07.22.18.43.36.61.54,0,0,0,0,0,0,.02.02.02.05,0,.07-.83.76-1.9,1.7-2.62,2.35-.53.48-1.08.94-1.61,1.42-.21.19-.4.36-.57.51ZM22.97,17.65c-.17,0-.33,0-.5,0-10.88,0-16.74,0-17.59,0-.05,0-.1.02-.14.01-.04,0-.04-.02-.01-.05.51-.45,1.33-1.16,2.45-2.14.14-.12.28-.26.41-.37.64-.56,1.21-1.06,1.71-1.51,0,0,.38-.34,1.14-1.01.11-.1.25-.19.36-.29,0,0,.02,0,.03,0,.53.44,1.07.88,1.63,1.3.37.29.88.48,1.36.48.38,0,.72-.08,1.03-.23.14-.07.36-.21.63-.43.24-.19.71-.56,1.4-1.11.02-.02.06-.02.08,0,.03.02.07.05.13.1.99.89,1.97,1.77,2.96,2.65.14.13.33.29.57.5,1.08.94,1.71,1.48,1.88,1.62.18.15.35.3.51.45.03.03.02.04-.02.04ZM25.1,16.14s0,.01,0,.02c-.01.01-.03.01-.04,0l-6.17-5.39s0,0,0,0c-.01-.01,0-.03,0-.04l6.17-5.17s.01,0,.02,0c.02,0,.03.01.03.03v10.55Z"
      />
    </g>
  </svg>
);

const Hands = (
  <svg
    id="Livello_2"
    data-name="Livello 2"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 227.05 195.18"
  >
    <defs>
      <style>
        {`
          .hands-cls-1 {
          fill: #eb74b1;
          opacity: .9;
        }

          .hands-cls-2 {
          fill: url(#Sfumatura_senza_nome_131-2);
        }

          .hands-cls-3 {
          fill: url(#Sfumatura_senza_nome_131);
        }
          `}
      </style>
      <linearGradient
        id="Sfumatura_senza_nome_131"
        data-name="Sfumatura senza nome 131"
        x1="64.88"
        y1="62.84"
        x2="227.05"
        y2="62.84"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#eb74b1" />
        <stop offset="1" stopColor="#dd177d" />
      </linearGradient>
      <linearGradient
        id="Sfumatura_senza_nome_131-2"
        data-name="Sfumatura senza nome 131"
        x1="13.38"
        y1="153.18"
        x2="97.24"
        y2="153.18"
      />
    </defs>
    <g id="Livello_1-2" data-name="Livello 1">
      <g>
        <path
          className="hands-cls-1"
          d="M179.62,126.83s11.79,18.47-7.01,31.68c-18.81,13.21-45.45,25.97-45.45,25.97,0,0-15.45,10-29.55-5.97L17.46,102.54H0V2.24l94.92,8.04,13.33,16.02,71.36,100.53Z"
        />
        <path
          className="hands-cls-3"
          d="M227.05,0l-95.9,8.21-59.02,46.67s-11.22,7.35-5.73,25.19c4.42,14.38,20.65,11.01,20.65,11.01l56.37-15.09,35.35,49.69,48.29-15.13V0Z"
        />
        <path
          className="hands-cls-2"
          d="M97.24,178.12l-10.96,11.57c-10.99,11.31-28.63,1.64-28.63,1.64,0,0-27.22-21.59-38.25-33.33-11.03-11.73-3.52-26.75-3.52-26.75l10.86-20.07,70.5,66.94Z"
        />
      </g>
    </g>
  </svg>
);

const Discount = (
  <svg
    id="Livello_2"
    data-name="Livello 2"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 231.41 247.97"
  >
    <defs>
      <style>
        {`
           .discount-cls-1 {
          fill: url(#Sfumatura_senza_nome_49);
        }

          .discount-cls-2 {
          fill: #fff;
        }

          .discount-cls-3 {
          fill: #eb74b1;
          opacity: .8;
        }
          `}
      </style>
      <linearGradient
        id="Sfumatura_senza_nome_49"
        data-name="Sfumatura senza nome 49"
        x1="0"
        y1="124.33"
        x2="231.41"
        y2="124.33"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#eb74b1" />
        <stop offset="1" stopColor="#dd177d" />
      </linearGradient>
    </defs>
    <g id="Livello_1-2" data-name="Livello 1">
      <g>
        <circle className="discount-cls-1" cx="115.71" cy="124.33" r="115.71" />
        <path
          className="discount-cls-2"
          d="M163.2,155.27c-1.87-1.54-4.63-1.28-6.17.59-9.46,11.46-23.4,18.04-38.25,18.04-20.94,0-38.87-13.06-46.12-31.45h44.01c2.42,0,4.38-1.96,4.38-4.38s-1.96-4.38-4.38-4.38h-46.55c-.58-3.03-.9-6.16-.9-9.36,0-1.39.07-2.77.19-4.13h47.27c2.42,0,4.38-1.96,4.38-4.38s-1.96-4.38-4.38-4.38h-45.74c5.69-21.1,24.98-36.67,47.86-36.67,11.89,0,23.39,4.28,32.38,12.04,1.83,1.58,4.6,1.38,6.18-.45,1.58-1.83,1.38-4.6-.45-6.18-10.58-9.14-24.11-14.17-38.11-14.17-27.73,0-50.99,19.46-56.88,45.44h-17.95c-2.42,0-4.38,1.96-4.38,4.38s1.96,4.38,4.38,4.38h16.66c-.1,1.37-.16,2.74-.16,4.13,0,3.18.27,6.31.76,9.36h-17.26c-2.42,0-4.38,1.96-4.38,4.38s1.96,4.38,4.38,4.38h19.4c7.64,23.32,29.6,40.21,55.44,40.21,17.47,0,33.88-7.74,45.01-21.23,1.54-1.87,1.28-4.63-.59-6.17Z"
        />
        <path
          className="discount-cls-3"
          d="M213.21,53.89l-12.99-48.48c-.68-2.54-2.61-4.47-5.15-5.16-2.55-.68-5.18.03-7.05,1.89l-.39.39-9.64,20.62c-.44.95-1.04,1.8-1.77,2.54-17.61-10.82-38.33-17.07-60.51-17.07-31.95,0-60.88,12.95-81.82,33.89l4.39,4.39C58.09,27.09,85.47,14.84,115.71,14.84c19.76,0,38.29,5.24,54.3,14.39l-17.07,8.01-.39.39c-1.38,1.38-2.14,3.21-2.14,5.14,0,3.31,2.23,6.21,5.41,7.06l48.47,12.99c.73.19,1.46.26,2.18.24,1.48-.06,2.92-.56,4.14-1.49.53-.41.99-.89,1.39-1.42.94-1.25,1.48-2.78,1.48-4.36,0-.64-.08-1.28-.25-1.91Z"
        />
        <path
          className="discount-cls-3"
          d="M193.13,201.76c-19.81,19.81-47.19,32.07-77.42,32.07-20.16,0-39.05-5.46-55.27-14.96l17.35-8.14.39-.39c1.38-1.38,2.14-3.21,2.14-5.14,0-3.31-2.23-6.21-5.41-7.06l-48.47-12.99c-.65-.17-1.3-.25-1.94-.24-1.57,0-3.1.51-4.38,1.49-.47.36-.89.78-1.26,1.24-1.02,1.28-1.61,2.88-1.61,4.53,0,.64.08,1.28.25,1.91l12.99,48.48c.68,2.54,2.61,4.47,5.15,5.16,2.55.68,5.18-.03,7.05-1.89l.39-.39,9.64-20.62c.41-.88.96-1.68,1.62-2.37,17.79,11.15,38.82,17.6,61.36,17.6,31.95,0,60.88-12.95,81.82-33.89l-4.39-4.39Z"
        />
      </g>
    </g>
  </svg>
);

const Savings = (
  <svg
    id="savings-svg-unique"
    data-name="savings-svg-unique"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 290 241.53"
  >
    <defs>
      <style>
        {`
          .savings-unique-cls-1 {
            mask: url(#savings-unique-mask-main);
          }

          .savings-unique-cls-2 {
            filter: url(#savings-unique-filter-main);
          }

          .savings-unique-cls-3 {
            mask: url(#savings-unique-mask-secondary);
          }

          .savings-unique-cls-4 {
            fill: #eb74b1;
          }

          .savings-unique-cls-5 {
            fill: #fff;
          }

          .savings-unique-cls-6 {
            fill: url(#savings-unique-gradient-circle);
            mix-blend-mode: multiply;
          }

          .savings-unique-cls-7 {
            fill: url(#savings-unique-gradient-base);
          }
        `}
      </style>

      <filter
        id="savings-unique-filter-main"
        x="106.11"
        y="0"
        width="133.23"
        height="133.23"
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodColor="#fff" result="bg" />
        <feBlend in="SourceGraphic" in2="bg" />
      </filter>

      <filter
        id="savings-unique-filter-secondary"
        x="106.11"
        y="-14163.12"
        width="133.23"
        height="32766"
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodColor="#fff" result="bg" />
        <feBlend in="SourceGraphic" in2="bg" />
      </filter>

      <mask
        id="savings-unique-mask-secondary"
        x="106.11"
        y="-14163.12"
        width="133.23"
        height="32766"
        maskUnits="userSpaceOnUse"
      />

      <linearGradient
        id="savings-unique-gradient-circle"
        x1="106.11"
        y1="66.61"
        x2="239.34"
        y2="66.61"
        gradientTransform="translate(97.69 -102.62) rotate(45)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#e6e6e6" />
        <stop offset="1" stopColor="#999" />
      </linearGradient>

      <mask
        id="savings-unique-mask-main"
        x="106.11"
        y="0"
        width="133.23"
        height="133.23"
        maskUnits="userSpaceOnUse"
      >
        <g className="savings-unique-cls-2">
          <g className="savings-unique-cls-3">
            <circle
              className="savings-unique-cls-6"
              cx="172.72"
              cy="66.61"
              r="66.61"
              transform="translate(3.49 141.65) rotate(-45)"
            />
          </g>
        </g>
      </mask>

      <linearGradient
        id="savings-unique-gradient-base"
        data-name="savings-unique-gradient-base"
        x1="0"
        y1="178.09"
        x2="290"
        y2="178.09"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#eb74b1" />
        <stop offset="1" stopColor="#dd177d" />
      </linearGradient>
    </defs>

    <g id="savings-layer-unique" data-name="savings-layer-unique">
      <g>
        <g>
          <g className="savings-unique-cls-1">
            <circle
              className="savings-unique-cls-4"
              cx="172.72"
              cy="66.61"
              r="66.61"
              transform="translate(3.49 141.65) rotate(-45)"
            />
          </g>

          <path
            className="savings-unique-cls-5"
            d="M175.53,103.64c3.31,0,6.21-2.23,7.06-5.41l12.99-48.47c.59-2.21.14-4.51-1.25-6.32-1.38-1.79-3.53-2.86-5.77-2.86-.64,0-1.28.08-1.91.25l-48.48,12.99c-2.54.68-4.47,2.61-5.16,5.16-.68,2.55.03,5.18,1.89,7.05l.39.39,20.62,9.64c1.92.9,3.47,2.45,4.37,4.37l9.71,20.69.39.39c1.38,1.38,3.21,2.14,5.14,2.14"
          />
        </g>

        <path
          className="savings-unique-cls-7"
          d="M40.73,236.39L4.75,199.2c-6.89-7.12-6.19-18.63,1.53-24.85l44.73-36.11c11.85-9.57,26.62-14.78,41.85-14.78h90.95c10.24,0,18.54,8.3,18.54,18.54h0c0,10.24-8.3,18.54-18.54,18.54h-50.99c-3.23,0-5.85,2.62-5.85,5.85h0c0,3.23,2.62,5.85,5.85,5.85h45.44c10.66,0,21.03-3.51,29.5-9.98l58.3-44.53c5.25-4.01,12.52-4.09,17.85-.18h0c7.22,5.29,8.19,15.7,2.07,22.22l-66.74,71.15c-8.46,9.02-20.27,14.13-32.63,14.13h-100.59c-5.3,0-10.42,1.95-14.37,5.47l-7.57,6.74c-6.75,6.02-17.05,5.63-23.34-.87Z"
        />
      </g>
    </g>
  </svg>
);

const Orders2 = (
  <svg
    id="Livello_2"
    data-name="Livello 2"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 317.04 250.62"
  >
    <defs>
      <style>
        {`
          .orders-cls-1, .orders-cls-2 {
          fill: #eb74b1;
        }

          .orders-cls-3 {
          fill: #fff;
        }

          .orders-cls-2 {
          opacity: .9;
        }

          .orders-cls-4 {
          fill: url(#Sfumatura_senza_nome_131);
        }
          `}
      </style>
      <linearGradient
        id="Sfumatura_senza_nome_131"
        data-name="Sfumatura senza nome 131"
        x1="6.13"
        y1="117.59"
        x2="317.04"
        y2="117.59"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#eb74b1" />
        <stop offset="1" stopColor="#dd177d" />
      </linearGradient>
    </defs>
    <g id="Livello_1-2" data-name="Livello 1">
      <g>
        <circle className="orders-cls-2" cx="74.94" cy="213.41" r="37.22" />
        <circle className="orders-cls-2" cx="276.75" cy="213.41" r="37.22" />
        <path
          className="orders-cls-4"
          d="M314.95,167.38c-5.63-5.61-15.15-12.17-29.48-13.13l-49.98-104.63c-10.79-20.83-36.67-19.92-36.67-19.92h-33.91c-5.66,0-10.3,4.63-10.3,10.3s4.63,10.3,10.3,10.3l30.26.05s12.37-.27,14.59,15.57l7.31,80.26s6.93,40.13-67.41,32.64c-6.48-30.19-27.63-52.24-60.7-52.24-40.22,0-82.82,32.6-82.82,72.82,0,2.05.11,4.08.27,6.09h145.1s0-.1,0-.14c49.47-.17,94.71-.45,94.71-.45l66.18-25.71c4.84-1.88,6.22-8.14,2.55-11.81Z"
        />
        <rect
          className="orders-cls-1"
          y="0"
          width="126.69"
          height="126.69"
          rx="12"
          ry="12"
        />
        <path
          className="orders-cls-3"
          d="M69.83,97.7c3.31,0,6.21-2.23,7.06-5.41l12.99-48.47c.59-2.21.14-4.51-1.25-6.32-1.38-1.79-3.53-2.86-5.77-2.86-.64,0-1.28.08-1.91.25l-48.48,12.99c-2.54.68-4.47,2.61-5.16,5.16-.68,2.55.03,5.18,1.89,7.05l.39.39,20.62,9.64c1.92.9,3.47,2.45,4.37,4.37l9.71,20.69.39.39c1.38,1.38,3.21,2.14,5.14,2.14"
        />
      </g>
    </g>
  </svg>
);

export const icons = {
  Check,
  ThreeDots,
  Sun,
  Moon,
  Bell,
  EyeOpen,
  EyeClosed,
  Hamburger,
  Close,
  Account,
  AccountCircle,
  Address,
  Settings,
  Bills,
  Edit,
  Pause,
  Resume,
  Remove,
  Wishlist,
  Help,
  Orders,
  Arrow,
  ArrowCircle,
  ArrowSquare,
  Search,
  SearchCircle,
  Visa,
  Maestro,
  Amex,
  CreditCard,
  Paypal,
  ApplePay,
  GooglePay,
  AmazonPay,
  Facebook,
  Instagram,
  Twitter,
  TikTok,
  Linkedin,
  Youtube,
  Whatsapp,
  Square,
  Squares,
  Warning,
  ArrowDown,
  ArrowUpDown,
  ArrowOutlineUp,
  ArrowOutlineDown,
  Download,
  Filters,
  Filters2,
  Info,
  Alert,
  ChartColumn,
  Clock,
  ChevronRight,
  ChevronLeft,
  Truck,
  PickUpLocation,
  Locker,
  Share,
  Star,
  FileArchived,
  FileVerified,
  FileRejected,
  RefreshCW,
  ManualUpload,
  Triangle,
  Leaf,
  DrawerArrows,
  Home,
  Productivity,
  Users,
  FolderOpen,
  Payments,
  DoubleArrow,
  Logout,
  FilterArrowUpDown,
  DrawerArrow,
  UserCircle,
  Documents,
  Money,
  KPI,
  Heart,
  Message,
  Bin,
  Mail,
  Hands,
  Discount,
  Savings,
  Orders2,
};
